import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import { useNavigate } from "react-router-dom";
import MDBox from "components/MDBox";
import Refresh from '@mui/icons-material/Refresh';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';


import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,

} from "@mui/material";

import { Grid, MenuItem, Select, InputLabel, FormControl, FormHelperText, TextField, Typography, Box, Chip, Button, FormControlLabel } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";
import bgImage from "assets/images/backgroundsjust.png";
import logo from "assets/images/logo.png";
import Swal from "sweetalert2";
import Checkbox from "@mui/material/Checkbox";
// Line 25 (or near other icon imports like CheckCircleIcon, InsertPhotoIcon)
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import api from "core/interceptors/api";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import { Business, Category, Person, Phone, Email, AccountBalance, CreditCard, AccountBox, AssignmentInd, LocalAtm, LocationOn, HomeAccountBalance, Payment } from '@mui/icons-material';
import { Cancel } from "@mui/icons-material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import KeywordsInput from "layouts/tables/Product_Details/KeywordsInput";
import { validateBusinessName, validateOwnerName, validateBusinessNameOthers, validateBusinessCategory, validateEmails } from "layouts/tables/validations";
import { validateMobileNumber } from "layouts/tables/validations";
import { validateEmail } from "layouts/tables/validations";
import { validatePassword } from "layouts/tables/validations";
import { validateOtp } from "layouts/tables/validations";
import { validateBankAccountNumber } from "layouts/tables/validations";
import { validateIFSCCode } from "layouts/tables/validations";
import { validateName } from "layouts/tables/validations";
import { validatePanCardNumber } from "layouts/tables/validations";
import { validateGSTNumber } from "layouts/tables/validations";
import { validateFile } from "layouts/tables/validations";
import { validateServiceType } from "layouts/tables/validations";
import { validateOperatingLocation } from "layouts/tables/validations";
import { validateHomeAddress } from "layouts/tables/validations";
import { validateExperience } from "layouts/tables/validations";
import { validateDetails } from "layouts/tables/validations";
import { validateFiles } from "layouts/tables/validations";
import { IconButton, InputAdornment } from "@mui/material";




function Cover() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [experienceCertificates, setExperienceCertificates] = useState([]);
  const [workPlaceGps, setWorkPlaceGps] = useState(null);
  const [profilephoto, setProfilephoto] = useState(null);
  const [idphoto, setIDPhoto] = useState([]);
  const [Input, setInput] = useState({});
  const [Inputservices, setInputservices] = useState({ subservicecategory: [], });
  const [validationErrors, setValidationErrors] = useState({});
  const [isEditingStep1, setIsEditingStep1] = useState(false);
  const [isEditingStep2, setIsEditingStep2] = useState(false);
  const [getrole, setGetrole] = useState(null);
  const [loading, setLoading] = useState(false);
  const [termsList, setTermsList] = useState("");
  const [servicetype, setServicetype] = useState([]);
  const [customService, setCustomService] = useState("");
  const [isEditingStep3, setIsEditingStep3] = useState(false);
  const [isEditingStep4, setIsEditingStep4] = useState(false);
  const [isEditingStep6, setIsEditingStep6] = useState(false);
  const [isEditingStep7, setIsEditingStep7] = useState(false);
  const [newpreviewVideos, setPreviewVideos] = useState([]);
  const [newVideos, setNewVideos] = useState([]);
  const [mobileNumberService, setServiceMobileNumberService] = useState("");
  const [otpService, setOtpService] = useState("");
  const [otpSentService, setOtpSentService] = useState(false);
  const [otpVerifiedService, setOtpVerifiedService] = useState(false);
  const [otpErrorService, setOtpErrorService] = useState("");
  const [timerService, setTimerService] = useState(0); // Store countdown time
  const [mobileNumber, setMobileNumber] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [email, setEmail] = useState("");
  const token = localStorage.getItem("token");

  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [otpEmail, setOtpEmail] = useState("");
  const [otpSentEmail, setOtpSentEmail] = useState(false);
  const [otpVerifiedEmail, setOtpVerifiedEmail] = useState(false);
  const [otpErrorEmail, setOtpErrorEmail] = useState("");
  const [timer, setTimer] = useState(0); // Store countdown time
  const [timerEmail, setTimerEmail] = useState(0); // Store countdown time
  const [serviceOptions, setServiceOptions] = useState([]);
  const [businessCategoryOptions, setBusinessCategoryOptions] = useState([]);
  const [specializations, setSpecializations] = useState([]);
  const [newSpecialization, setNewSpecialization] = useState("");
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(""); // Generated captcha
  const [captchaInput, setCaptchaInput] = useState(""); // User input
  const [showCaptcha, setShowCaptcha] = useState(false);

  // Add this line with your other useState declarations, e.g., around line 74
  const [showPasswordService, setShowPasswordService] = useState(false);
  // Line 74 (or near other useState declarations)
  const [showPassword, setShowPassword] = useState(false);
  const [customServiceEnabled, setCustomServiceEnabled] = useState(false);
  const [errors, setError] = useState({});
  const [couponCode, setCouponCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [validCoupon, setValidCoupon] = useState(false);
  const [referralCode, setReferralCode] = useState("");

  const [files, setFiles] = useState({
    vendorPhoto: null,
    shopPhoto: null,
    gpsPhoto: null,
    userProofDoc: [], // For multiple files
  });
  const [paymentPlans, setPaymentPlans] = useState([]);

  const [fileErrors, setFileErrors] = useState({
    profilephoto: "",
    idphoto: "",
    experienceCertificates: "",
    workPlaceGps: "",
  });
  const isFormValid1 = () => {
    // Ensure businessCategory is treated as a string
    const businessCategoryStr = typeof businessCategory === "string" ? businessCategory : "";

    const businessNameValid = (Input.businessName || "").trim() !== "";
    const businessTypeValid = (Input.businessType || "").trim() !== "";
    const businessCategoryValid = businessCategoryStr.trim() !== "";
    const othersValid = businessCategoryStr !== "Others" || ((Input.others || "").trim() !== "");
    const ownerNameValid = (Input.ownerName || "").trim() !== "";
    const mobileValid = ((mobileNumber || "").trim().replace(/\D/g, "").length === 10);
    const otpMobileValid = otpVerified;
    const emailValid = (email || "").trim() !== "";


    // const otpEmailValid = otpVerifiedEmail;
    const passwordValid = (Input.password || "").trim() !== "";
    const keywordsValid = (Input.keywords && Input.keywords.length > 0);
    const noErrors = !validationErrors.businessName && !validationErrors.businessType && !validationErrors.businessCategory && !validationErrors.ownerName && !validationErrors.password
    // Log individual validation results
    const validationResults = {
      businessNameValid,
      businessTypeValid,
      businessCategoryValid,
      othersValid,
      ownerNameValid,
      mobileValid,
      otpMobileValid,
      emailValid,
      //otpEmailValid,
      passwordValid,
      keywordsValid,
      noErrors
    };

    console.log(validationResults);

    // Return true only if every individual check passes
    return Object.values(validationResults).every(Boolean);
  };
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error"); // 'success' | 'error' | 'warning' | 'info'

  const [sameAddress, setSameAddress] = useState(false);
  const [businessCategory, setBusinessCategory] = useState([]);
  const [availability, setAvailability] = useState({
    monday: { enabled: false },
    tuesday: { enabled: false },
    wednesday: { enabled: false },
    thursday: { enabled: false },
    friday: { enabled: false },
    saturday: { enabled: false },
    sunday: { enabled: false },

  });
  const generateCaptcha = () => {
    const random = Math.floor(100 + Math.random() * 900).toString(); // e.g. 472
    setCaptchaValue(random);
    setCaptchaInput(""); // Reset input field
  };

  const iconStyle = { marginRight: 8, color: "#1976d2" };
  const imagePreviewStyle = {
    width: 120,
    height: 120,
    objectFit: "cover", // Ensures the image fills the box without distortion
    borderRadius: 8,    // Optional: Rounded corners
    marginBottom: 10,
    display: "block",
    border: "1px solid #ccc"
  };

  useEffect(() => {
    const fetchServiceTypes = async () => {
      try {

        const response = await api.get("/service_management/service_types",);

        if (response.data.success) {
          setServiceOptions(response.data.service_types);

        }
      } catch (error) {
        console.error("Error fetching service types:", error);
      }
    };

    const fetchBusinessCategory = async () => {
      try {

        const response = await api.get("/vendor_management/business_category",);
        console.log(response.data);
        if (response.data.success) {
          setBusinessCategoryOptions(response.data.business_catgory);

        }
      } catch (error) {
        console.error("Error fetching service types:", error);
      }
    };
    fetchBusinessCategory();
    fetchServiceTypes();
  }, []);

  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    const requiredFields = [
      Inputservices.businessName,
      Inputservices.email,
      Inputservices.password,
      mobileNumberService,
      servicetype.length > 0,
      Inputservices.subservicecategory?.length > 0,
      Inputservices.keywords?.length > 0,
    ];

    const hasAllFields = requiredFields.every(Boolean);

    const hasNoErrors =
      !validationErrors.businessName &&
      !validationErrors.email &&
      !validationErrors.password &&
      !validationErrors.mobileNumber &&
      !validationErrors.serviceType &&
      !validationErrors.subservicecategory;

    setIsFormValid(hasAllFields && hasNoErrors);
  }, [
    Inputservices.businessName,
    Inputservices.email,
    Inputservices.password,
    Inputservices.subservicecategory,
    Inputservices.keywords,
    servicetype,
    mobileNumberService,
    validationErrors,
  ]);
  useEffect(() => {
    fetchTerms();
  }, []);

  useEffect(() => {
    const fetchPaymentPlans = async () => {
      try {
        const res = await api.get("/payment_plans/get");
        const allPlans = res.data || [];

        console.log("All Payment Plans:", allPlans);
        console.log("Current Role:", getrole);

        const filteredPlans = allPlans.filter(plan => {
          if (getrole === "Vendors") {
            return plan.plan_type === "vendor";
          } else {
            return plan.plan_type === "service";
          }
        });

        console.log("Filtered Plans:", filteredPlans);
        setPaymentPlans(filteredPlans);
      } catch (err) {
        console.error("Failed to fetch payment plans:", err);
      }
    };

    if (getrole) fetchPaymentPlans();
  }, [getrole]);


  const fetchSpecializations = async (selectedServices) => {
    try {
      console.log("📤 Fetching specializations for:", selectedServices);

      const response = await api.post(`/service_management/service_specializations/get_specializations`, { serviceTypeIds: selectedServices });

      console.log("📥 API Response:", response.data);

      if (response.data.status === 1 && Array.isArray(response.data.service_specializations)) {
        setSpecializations((prevSpecs) => {
          // Preserve custom specializations while merging new ones
          const customSpecs = prevSpecs.filter(spec => !spec.fromAPI);
          const fetchedSpecs = response.data.service_specializations.map(spec => ({
            ...spec,
            fromAPI: true // Mark fetched specializations
          }));

          // Use Map to remove duplicates based on service_type
          const mergedSpecs = new Map([
            ...customSpecs.map(spec => [spec.service_type, spec]),
            ...fetchedSpecs.map(spec => [spec.service_type, spec])
          ]);

          return Array.from(mergedSpecs.values());
        });
      } else {
        console.warn("⚠️ No specializations found, keeping custom ones.");
      }
    } catch (error) {
      console.error("❌ Fetch Error:", error.response ? error.response.data : error.message);
    }
  };



  const handleServiceTypeChange = (event) => {
    const selectedServices = event.target.value;
    console.log("🛠 Selected Services:", selectedServices);

    // Update serviceType state
    setServicetype(selectedServices);

    // Validate service type selection
    const error = validateServiceType(selectedServices);
    setValidationErrors((prev) => ({
      ...prev,
      serviceType: error,
    }));

    // Update specializations state
    setSpecializations((prevSpecs) => {
      console.log("🔍 Previous Specializations:", prevSpecs);

      const existingServiceMap = new Map(
        prevSpecs.map((spec) => [spec.service_type, spec])
      );

      const updatedSpecs = selectedServices.map((service) =>
        existingServiceMap.get(service) || {
          service_type: service,
          service_specializations: "",
          fromAPI: false,
        }
      );

      console.log("✅ Final Updated Specializations:", updatedSpecs);
      return updatedSpecs;
    });

    // Fetch new specializations only if services are selected
    if (selectedServices.length > 0) {
      fetchSpecializations(selectedServices);
    }
  };

  const handleAddCustomService = (event) => {
    if (event.key === "Enter" && customService.trim() !== "") {
      event.preventDefault(); // Prevent accidental form submission

      const newService = customService.trim();

      // 1. Add to service options if not already present
      setServiceOptions((prevOptions) => {
        const exists = prevOptions.some((option) => option.service_type.toLowerCase() === newService.toLowerCase());
        if (!exists) {
          console.log(`➕ Adding new service: ${newService}`);
          return [...prevOptions, { id: `custom-${Date.now()}`, service_type: newService }];
        }
        console.log(`⚠️ Service "${newService}" already exists.`);
        return prevOptions;
      });

      // 2. Add to specialization list if not already present
      setSpecializations((prevSpecs) => {
        const exists = prevSpecs.some((spec) => spec.service_type.toLowerCase() === newService.toLowerCase());
        if (!exists) {
          console.log(`✅ Adding specialization container for: ${newService}`);
          return [...prevSpecs, { service_type: newService, service_specializations: "", fromAPI: false }];
        }
        console.log(`⚠️ Specialization for "${newService}" already exists.`);
        return prevSpecs;
      });

      // 3. Select the service immediately
      setServicetype((prev) => {
        if (!prev.includes(newService)) {
          return [...prev, newService];
        }
        console.log(`⚠️ Service "${newService}" already selected.`);
        return prev;
      });

      // 4. Clear validation error if any
      setValidationErrors((prev) => ({
        ...prev,
        serviceType: "",
      }));

      // 5. Reset input
      setCustomService("");
      setCustomServiceEnabled(false); // Optional: auto-hide input field
    }
  };

  // Remove a single chip
  const handleRemoveChip = (chipToRemove) => {
    const updatedServiceTypes = servicetype.filter((chip) => chip !== chipToRemove);
    setServicetype(updatedServiceTypes);

    // Remove specializations related to removed service
    const removedSpecializations =
      specializations.find((s) => s.service_type === chipToRemove)?.service_specializations
        ?.split(",")
        .map((s) => s.trim()) || [];

    const updatedSubSpecializations = Inputservices.subservicecategory?.filter(
      (spec) => !removedSpecializations.includes(spec)
    );

    setInputservices((prev) => ({
      ...prev,
      subservicecategory: updatedSubSpecializations,
    }));

    // ✅ Remove the specialization TextField input
    setNewSpecialization((prev) => {
      const updated = { ...prev };
      delete updated[chipToRemove];
      return updated;
    });

    // ✅ Remove the service entirely from specializations array (which drives the rendering)
    setSpecializations((prev) =>
      prev.filter((spec) => spec.service_type !== chipToRemove)
    );

    // ✅ Validation update
    setValidationErrors((prev) => ({
      ...prev,
      serviceType: updatedServiceTypes.length === 0 ? "Please select at least one service type." : "",
      subservicecategory:
        updatedSubSpecializations.length === 0 ? "Please select at least one specialization." : "",
    }));
  };




  const toggleSpecialization = (specialization) => {
    setInputservices((prev) => {
      const updatedSpecializations = prev.subservicecategory.includes(specialization)
        ? prev.subservicecategory.filter((spec) => spec !== specialization)
        : [...prev.subservicecategory, specialization];

      return { ...prev, subservicecategory: updatedSpecializations };
    });
  };

  const handleRemoveSpecialization = (specializationToRemove) => {
    setInputservices((prev) => ({
      ...prev,
      subservicecategory: prev.subservicecategory.filter((spec) => spec !== specializationToRemove),
    }));
  };

  const handleNewSpecializationChange = (serviceType, value) => {
    setNewSpecialization((prev) => ({
      ...prev,
      [serviceType]: value, // Store value based on service type
    }));
  };

  // Adds specialization to the respective service type
  const addSpecialization = (serviceType) => {
    if (!newSpecialization[serviceType]?.trim()) return;

    setSpecializations((prev) =>
      prev.map((service) =>
        service.service_type === serviceType
          ? {
            ...service,
            service_specializations: service.service_specializations
              ? `${service.service_specializations}, ${newSpecialization[serviceType]}`
              : newSpecialization[serviceType],
          }
          : service
      )
    );

    // Clear input after adding
    setNewSpecialization((prev) => ({ ...prev, [serviceType]: "" }));
  };
  const handleBusinessCategoryChange = (event) => {
    const selected = event.target.value;
    setBusinessCategory(selected);

    if (selected !== "Others") {
      setInput((prev) => ({ ...prev, others: "" })); // Clear others if not selected
    }
  };
  const handleSameAddressChange = (event) => {
    setSameAddress(event.target.checked);
    if (event.target.checked) {
      setInputservices((prev) => ({
        ...prev,
        homeaddress: prev.operatinglocation, // Copy home address
      }));
    }
  };
  const handleServiceMobileChange = async (event) => {
    const value = event.target.value;

    // Step 1: Update state
    setServiceMobileNumberService(value);

    // Step 2: Validate format
    const error = validateMobileNumber(value);
    setValidationErrors((prev) => ({
      ...prev,
      mobileNumber: error,
    }));

    // Step 3: Reset OTP-related state if length isn't exactly 10
    if (value.length !== 10) {
      setOtpVerifiedService(false);
      setOtpSentService(false);
      setOtpService("");
      setTimerService(0);
      return;
    }

    // Step 4: Skip backend check if format error exists
    if (error) return;

    // Step 5: Check for duplicate mobile in backend
    try {
      const response = await api.post("/services_register/check_duplicate_mobile", {
        mobile_number: value,
      });

      if (response.data.exists) {
        setValidationErrors((prev) => ({
          ...prev,
          mobileNumber: "Mobile number already registered",
        }));

        // Reset OTP again just in case
        setOtpVerifiedService(false);
        setOtpSentService(false);
        setOtpService("");
        setTimerService(0);
      } else {
        setValidationErrors((prev) => ({
          ...prev,
          mobileNumber: "",
        }));
      }
    } catch (err) {
      console.error("Duplicate check failed:", err);
      setValidationErrors((prev) => ({
        ...prev,
        mobileNumber: "Unable to verify mobile number right now",
      }));
    }
  };


  // Handle sending OTP for mobile number
  const handleServiceSendOtp = async () => {
    if (mobileNumberService.length !== 10) {
      setValidationErrors((prev) => ({ ...prev, mobileNumber: "Enter a valid 10-digit number" }));
      return;
    }
    console.log(mobileNumberService)
    try {
      const response = await api.post("/otp_email/generate_mobile_otp", { mobile_number: mobileNumberService });

      if (response.data.status === 1) {
        setOtpSentService(true); // Mark OTP as sent
        console.log("Mobile OTP sent successfully");
        startServiceMobileTimer(120); // Start the 120s countdown
      } else {
        console.error("Failed to send mobile OTP:", response.data.message);
      }
    } catch (error) {
      console.error("Error sending mobile OTP:", error);
    }
  };

  // Function to start the mobile OTP timer
  const startServiceMobileTimer = (duration) => {
    setTimerService(duration);

    const interval = setInterval(() => {
      setTimerService((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  const validateCoupon = async () => {
    console.log("validateCoupon function started!"); // This confirms button click

    try {
      const res = await api.get("/coupons/"); // Attempt to fetch coupons
      const fetchedCouponList = res.data?.coupons || []; // Store fetched data in a new variable
      console.log("Available Coupons (after fetch):", fetchedCouponList); // Log the *actual* fetched list

      const matched = fetchedCouponList.find(c => c.coupon_id === couponCode.trim().toUpperCase());

      if (!matched) {
        throw new Error("Invalid coupon"); // Throw a specific error for clarity
      }

      const now = new Date();
      const start = new Date(matched.start_date);
      const end = new Date(matched.end_date);

      if (now >= start && now <= end) {
        setDiscount(matched.percentage);
        setValidCoupon(true);
        Swal.fire("Coupon Applied", `${matched.percentage}% off`, "success");
      } else {
        setDiscount(0);
        setValidCoupon(false);
        Swal.fire("Coupon Expired", "This coupon is not valid today", "info");
      }
    } catch (err) {
      setDiscount(0);
      setValidCoupon(false);
      console.error("Error during coupon validation or fetch:", err); // Log the full error object!
      let errorMessage = "An unexpected error occurred.";
      if (err.message === "Invalid coupon") {
        errorMessage = "Coupon code not found.";
      } else if (err.response && err.response.data && err.response.data.message) {
        errorMessage = err.response.data.message; // From API response error
      } else if (err.message) {
        errorMessage = err.message; // General JavaScript error message
      }
      Swal.fire("Alert", errorMessage, "info");
    }
  };
  const getDiscountedAmount = (amount = 0) => {
    return Math.round(amount - (amount * (discount || 0)) / 100);
  };


  // Handle OTP input change
  const handleServiceOtpChange = (e) => {
    const value = e.target.value;
    setOtpService(value);

    const error = validateOtp(value);
    setOtpErrorService(error);
  };
  // Handle mobile OTP verification
  const handleServiceVerifyOtp = async () => {
    if (!otpService || otpService.length !== 6) {
      setOtpError("Please enter a valid 6-digit OTP.");
      return;
    }

    try {
      const response = await api.post("/otp_email/validate_otp", {
        email_id: mobileNumberService,
        otp: otpService,
      });

      if (response.data.status === 1) {
        setOtpVerifiedService(true);
        setOtpSentService(false);
        setOtpErrorService("");
        console.log("Mobile OTP verified successfully!");
      } else {
        setOtpErrorService("Invalid OTP. Try again.");
        setOtpVerifiedService(false);
      }
    } catch (error) {
      console.error("Error verifying mobile OTP:", error);
      setOtpErrorService("Invalid OTP");
      setOtpVerifiedService(false);
    }
  };

  // Service Mobile OTP ends
  const handleSingleFileChange = (e, fieldName, setFiles, setError) => {
    const file = e.target.files[0];

    if (file) {
      const validation = validateFile(file);
      if (!validation.valid) {
        setError((prevErrors) => ({ ...prevErrors, [fieldName]: validation.error }));
        return;
      }

      setError((prevErrors) => ({ ...prevErrors, [fieldName]: '' }));
      setFiles((prevFiles) => ({ ...prevFiles, [fieldName]: file }));
    }
  };

  // Function to handle multiple file uploads with a limit of 5
  const handleMultipleFileChange1 = (e, fieldName, setFiles, setError, maxFiles = 2) => {
    const newFiles = Array.from(e.target.files);
    const existingFiles = setFiles[fieldName] || [];

    if (existingFiles.length + newFiles.length > maxFiles) {
      setError((prevErrors) => ({
        ...prevErrors,
        [fieldName]: `You can upload a maximum of ${maxFiles} images.`,
      }));
      setFiles((prevFiles) => ({ ...prevFiles, [fieldName]: [] })); // Clear selected images
      return;
    }

    let validFiles = [];
    let errorMsg = '';

    newFiles.forEach((file) => {
      const validation = validateFile(file);
      if (validation.valid) {
        validFiles.push(file);
      } else {
        errorMsg = validation.error;
      }
    });

    if (errorMsg) {
      setError((prevErrors) => ({ ...prevErrors, [fieldName]: errorMsg }));
      setFiles((prevFiles) => ({ ...prevFiles, [fieldName]: [] })); // Clear selected images
      return;
    }

    setError((prevErrors) => ({ ...prevErrors, [fieldName]: '' }));
    setFiles((prevFiles) => ({
      ...prevFiles,
      [fieldName]: [...validFiles].slice(0, maxFiles), // Ensure max limit
    }));
  };


  const handleMobileChange = async (event) => {
    const value = event.target.value;
    setMobileNumber(value);

    // Validate the mobile number format
    const errorMessage = validateMobileNumber(value);

    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      mobileNumber: errorMessage,
    }));

    // Reset OTP state if number is invalid
    if (errorMessage) {
      setOtpVerified(false);
      setOtpSent(false);
      setOtp("");
      setTimer(0);
      return;
    }

    // ✅ Only trigger duplicate check if number is exactly 10 digits
    if (value.length === 10) {
      try {
        const response = await api.post("/vendor_register/check_duplicate_mobile", { mobile_number: value });

        if (response.data.exists) {
          setValidationErrors((prev) => ({
            ...prev,
            mobileNumber: "Mobile number already registered",
          }));
        } else {
          setValidationErrors((prev) => ({
            ...prev,
            mobileNumber: "", // Clear any existing error
          }));
        }
      } catch (err) {
        console.error("Mobile number check failed:", err);
        setValidationErrors((prev) => ({
          ...prev,
          mobileNumber: "Error checking mobile number",
        }));
      }
    }
  };



  // Handle sending OTP for mobile number
  const handleSendOtp = async () => {
    if (mobileNumber.length !== 10) {
      setValidationErrors((prev) => ({ ...prev, mobileNumber: "Enter a valid 10-digit number" }));
      return;
    }
    console.log(mobileNumber)
    try {
      const response = await api.post("/otp_email/generate_mobile_otp", { mobile_number: mobileNumber });

      if (response.data.status === 1) {
        setOtpSent(true); // Mark OTP as sent
        console.log("Mobile OTP sent successfully");
        startMobileTimer(120); // Start the 120s countdown
      } else {
        console.error("Failed to send mobile OTP:", response.data.message);
      }
    } catch (error) {
      console.error("Error sending mobile OTP:", error);
    }
  };

  // Function to start the mobile OTP timer
  const startMobileTimer = (duration) => {
    setTimer(duration);

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // Handle OTP input change
  const handleOtpChange = (e) => {
    const value = e.target.value;
    setOtp(value);

    // Validate OTP and set error message
    const errorMessage = validateOtp(value);
    setOtpError(errorMessage);  // Set the error message
  };


  // Handle mobile OTP verification
  const handleVerifyOtp = async () => {
    if (!otp || otp.length !== 6) {
      setOtpError("Please enter a valid 6-digit OTP.");
      return;
    }

    try {
      const response = await api.post("/otp_email/validate_otp", {
        email_id: mobileNumber,
        otp: otp,
      });

      if (response.data.status === 1) {
        setOtpVerified(true);
        setOtpSent(false);
        setOtpError("");
        console.log("Mobile OTP verified successfully!");
      } else {
        setOtpError("Invalid OTP. Try again.");
        setOtpVerified(false);
      }
    } catch (error) {
      console.error("Error verifying mobile OTP:", error);
      setOtpError("Invalid OTP");
      setOtpVerified(false);
    }
  };
  const handleProceedToRazorpay = (selectedPlan) => {
    console.log("User selected:", selectedPlan);
    // Pass this plan’s details (amount, ID, etc.) to Razorpay integration
    // Call your payment API
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  // Handle email input change
  const handleEmailChange = async (event) => {
    const newEmail = event.target.value;
    setEmail(newEmail);

    // Step 1: Validate email format
    const errorMessage = validateEmails(newEmail);

    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      email: errorMessage,
    }));

    // Step 2: Reset OTP-related state if needed
    if (otpVerifiedEmail || otpSentEmail) {
      setOtpVerifiedEmail(false);
      setOtpSentEmail(false);
      setOtpEmail("");
      setTimerEmail(0);
    }

    // Step 3: If format is invalid, skip backend check
    if (errorMessage) return;

    // Step 4: Check duplicate in backend
    try {
      const response = await api.post("/vendor_register/check_duplicate_email", {
        email: newEmail,
      });

      if (response.data.exists) {
        setValidationErrors((prev) => ({
          ...prev,
          email: "Email is already registered",
        }));

        // Reset OTP again just to be safe
        setOtpVerifiedEmail(false);
        setOtpSentEmail(false);
        setOtpEmail("");
        setTimerEmail(0);
      } else {
        setValidationErrors((prev) => ({
          ...prev,
          email: "",
        }));
      }
    } catch (error) {
      console.error("Email check failed:", error);
      setValidationErrors((prev) => ({
        ...prev,
        email: "Unable to verify email right now",
      }));
    }
  };



  const handleEmailSendOtp = async () => {
    if (!isValidEmail(email)) return;

    try {
      const response = await api.post("/otp_email/generate_otp", { email_id: email });

      if (response.data.status === 1) {
        console.log("OTP sent successfully");

        setOtpSentEmail(true); // Mark OTP as sent
        setTimerEmail(180); // Start 120-second countdown
        startTimer(180); // Start countdown correctly
      } else {
        console.error("Failed to send OTP:", response.data.message);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  };


  // Function to start the 120s countdown and re-enable Resend OTP after timer ends
  const startTimer = (duration) => {
    setTimerEmail(duration);

    const interval = setInterval(() => {
      setTimerEmail((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setOtpSentEmail(false); // Re-enable "Send OTP" button after timer ends
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };


  const fetchTerms = async () => {
    setLoading(true);
    try {
      const response = await api.get("/terms/latest"); // endpoint for latest active terms
      if (response.data.status === 1) {
        setTermsList(response.data.terms); // store the object
      } else {
        Swal.fire("Error", response.data.msg || "Failed to load terms.", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to load terms.", "error");
    } finally {
      setLoading(false);
    }
  };


  // Handle OTP input change
  const handleEmailOtpChange = (e) => {
    const value = e.target.value;
    setOtpEmail(value);
    setOtpErrorEmail("");


    const errorMessage = validateOtp(value);
    setOtpErrorEmail(errorMessage);  // Set the error message
  };


  // Handle OTP verification
  const handleEmailVerifyOtp = async () => {
    if (!otpEmail || otpEmail.length !== 6) {
      setOtpErrorEmail("Please enter a valid 6-digit OTP.");
      return;
    }

    try {
      const response = await api.post("/otp_email/validate_otp", {
        email_id: email,
        otp: otpEmail,
      });

      if (response.data.status === 1) {
        setOtpVerifiedEmail(true);
        setOtpSentEmail(false);
        setOtpErrorEmail("");
        console.log("OTP verified successfully!");
      } else {
        setOtpErrorEmail("Invalid OTP. Try again.");
        setOtpVerifiedEmail(false);
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);

      setOtpErrorEmail("Invalid OTP");
      setOtpVerifiedEmail(false);
    }
  };


  const [selectedDays, setSelectedDays] = useState([]);

  const handleFileChange = (e, setFile, setError) => {
    const file = e.target.files[0]; // Get the first selected file
    const validation = validateFile(file);

    if (!validation.valid) {
      setError(validation.error);
      setFile('');
      return;
    }

    setError('');
    setFile(file);
  };
  const handleFileChangeservice = (e, setFile, fieldName) => {
    const file = e.target.files[0];
    const errors = validateFiles([file], "image");

    if (errors.length > 0) {
      setFileErrors((prev) => ({ ...prev, [fieldName]: errors.join(", ") }));
      return;
    }

    setFile(file);
    setFileErrors((prev) => ({ ...prev, [fieldName]: "" }));
  };


  const handleBackToStep1 = () => {
    setStep(1);
    setIsEditingStep1(true); // Enable editing mode
  };
  const handleBackToStep2 = () => {
    setStep(2);
    setIsEditingStep1(true); // Enable editing mode
  };

  const handleBackToStep3 = () => {
    setStep(2);
    setIsEditingStep2(true); // Enable editing mode
  };
  const handleBackToStep4 = () => {
    setStep(3);
    setIsEditingStep3(true); // Enable editing mode
  };
  const handleBackToStep5 = () => {
    setStep(4);
    setIsEditingStep4(true); // Enable editing mode
  };
  const handleBackToStep6 = () => {
    setStep(4);
    setIsEditingStep4(true); // Enable editing mode
  };
  const handleBackToStep7 = () => {
    setStep(6);
    setIsEditingStep6(true); // Enable editing mode
  };

  const handleBackToStep8 = () => {
    setStep(6);
    setIsEditingStep7(true);
    // Enable editing mode
  };
  const handleBackToStep9 = () => {
    // Decide whether to go back to Step 9 or Step 8 depending on your flow
    if (getrole === "Vendors") {
      setStep(7); // Or whichever is the review/upload step for vendors
    } else {
      setStep(8); // Or whichever is the review/upload step for service providers
    }
    // Optionally enable editing mode
    setIsEditMode(true);
  };
  const handleBackToStep10 = () => {
    setStep(9); // Go back from payment page to review page
    setIsEditMode(true); // If you want to allow editing on back
  };

  const [isEditMode, setIsEditMode] = useState(false);

  const handleEditModeToggle = () => {
    setIsEditMode(!isEditMode);
    if (!isEditMode) {
      handleBankDetailsSubmit();
    }
  };
  const handleRoleChange = (e) => {
    setGetrole(e.target.value);
    console.log(getrole);
  };


  const handleServiceBusinessInputChange = async (e) => {
    const { name, value } = e.target;

    // Step 1: Update the input state
    const updatedInput = { ...Inputservices, [name]: value };
    setInputservices(updatedInput);

    let error = "";

    // Step 2: Apply validation and handle email separately
    switch (name) {
      case "businessName":
        error = validateBusinessName(value);
        break;

      case "email":
        error = validateEmail(value); // validate format
        break;

      case "password":
        error = validatePassword(value);
        break;

      case "keywords":
        error = value.length === 0 ? "At least one keyword is required." : "";
        break;

      default:
        error = "";
    }

    // Step 3: Set initial error (format or empty string)
    setValidationErrors((prev) => ({
      ...prev,
      [name]: error,
    }));

    // Step 4: If the field isn't email or there's already an error (invalid format), exit
    if (name !== "email" || error) return;

    // Step 5: Check with backend for duplicate email
    try {
      const response = await api.post("/services_register/check_duplicate_email", {
        email: value,
      });

      if (response.data.exists) {
        setValidationErrors((prev) => ({
          ...prev,
          email: "Email is already registered",
        }));
      } else {
        setValidationErrors((prev) => ({
          ...prev,
          email: "", // Clear if valid and not duplicate
        }));
      }
    } catch (err) {
      console.error("Email duplicate check failed:", err);
      setValidationErrors((prev) => ({
        ...prev,
        email: "Unable to verify email right now",
      }));
    }
  };



  const handleBankDetailsChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;
    let errorMessage = "";
    if (name === "accountNumber") {
      errorMessage = validateBankAccountNumber(formattedValue);
    }
    else if (name === "ifscCode") {
      errorMessage = validateIFSCCode(formattedValue);
    }
    else if (name === "accountHolderName") {
      errorMessage = validateName(formattedValue);
    }
    else if (name === "panCardNumber") {
      errorMessage = validatePanCardNumber(formattedValue)
    }
    else if (name === "bankName") {
      errorMessage = validateName(formattedValue)
    }
    else if (name === "branchName") {
      errorMessage = validateName(formattedValue)
    }
    else if (name === "gstNumber") {
      errorMessage = validateGSTNumber(formattedValue)
    }
    setValidationErrors((prev) => ({ ...prev, [name]: errorMessage }));
    const updatedInput = { ...Input, [name]: formattedValue };
    setInput(updatedInput);
  };

  const handleservicesdetailsChange = (e) => {
    const { name, value } = e.target;

    // Handle multiselect array conversion
    const updatedValue =
      name === "subservicecategory" ? (typeof value === "string" ? value.split(",") : value) : value;

    // Update state
    setInputservices((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    // Run field-level validation
    let error = "";

    switch (name) {
      case "subservicecategory":
        error = updatedValue.length === 0 ? "Please select at least one specialization." : "";
        break;
      case "operatinglocation":
        error = validateOperatingLocation(value);
        break;
      case "homeaddress":
        if (!sameAddress) {
          error = validateHomeAddress(value);
        }
        break;
      case "experiance":
        error = validateExperience(value);
        break;
      case "details":
        error = validateDetails(value);
        break;
      default:
        break;
    }

    // Update validation errors
    setValidationErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };




  const handleMultipleFileChange = (e, setFiles, fieldName) => {
    const files = Array.from(e.target.files);
    const errors = validateFiles(files, "image");

    if (errors.length > 0) {
      setFileErrors((prev) => ({ ...prev, [fieldName]: errors.join(", ") }));
      return;
    }

    setFiles(files);
    setFileErrors((prev) => ({ ...prev, [fieldName]: "" }));
  };



  const handleBusinessInputChange = (e) => {
    const { name, value } = e.target;

    const updatedInput = { ...Input, [name]: value };
    setInput(updatedInput);


    let errorMessage = ""; // Declare the error message outside

    if (name === "businessName") {
      errorMessage = validateBusinessName(value); // Call validation function
    } else if (name === "businessCategory") {
      errorMessage = validateBusinessCategory(value);
    } else if (name === "others") {
      errorMessage = validateBusinessNameOthers(value);
    } else if (name === "ownerName") {
      errorMessage = validateOwnerName(value)
    } else if (name === "mobileNumber") {
      errorMessage = validateMobileNumber(value);
    } else if (name === "password") {
      errorMessage = validatePassword(value)
    }

    // Update validation errors
    setValidationErrors((prev) => ({ ...prev, [name]: errorMessage }));
  };
  const renderFormContent = () => {
    if (step === 1) {
      return (
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <MDBox mb={2}>
              <FormControl fullWidth>
                <InputLabel>Role</InputLabel>
                <Select
                  value={getrole}
                  onChange={handleRoleChange}
                  label="Role"
                  sx={{ height: 45 }}
                >

                  <MenuItem value="Vendors">Vendors</MenuItem>
                  <MenuItem value="Services">Service Providers</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
          </Grid>
          {(getrole === "Vendors" &&
            // <>
            //   <Grid item xs={12} sm={6} mt={1}>
            //     <MDBox margin="normal" fullWidth>
            //       <FormControl fullWidth error={!!validationErrors.businessName}>
            //         <TextField
            //           id="business-name"
            //           name="businessName"
            //           type="text"
            //           label="Business Name"
            //           variant="outlined"
            //           value={Input.businessName}
            //           onChange={handleBusinessInputChange}
            //           fullWidth
            //           error={!!validationErrors.businessName}  // ✅ Apply error to TextField
            //         />
            //         {validationErrors.businessName && (
            //           <FormHelperText>{validationErrors.businessName}</FormHelperText>
            //         )}
            //       </FormControl>
            //     </MDBox>
            //   </Grid>

            //   <Grid item xs={12} sm={6} mt={1}>
            //     <MDBox mb={2}>
            //       <FormControl fullWidth>
            //         <InputLabel id="business-type-label">Business Type</InputLabel>
            //         <Select
            //           labelId="business-type-label"
            //           name="businessType"
            //           value={Input.businessType || ""}
            //           onChange={handleBusinessInputChange}
            //           label="Business Type" // Label is inside the TextField
            //           fullWidth
            //           sx={{ height: 45 }}
            //         >
            //           <MenuItem value="Retail">Retail</MenuItem>
            //           <MenuItem value="Wholesale">Wholesale</MenuItem>
            //           <MenuItem value="Retail & Wholesale">Retail & Wholesale</MenuItem>
            //         </Select>
            //       </FormControl>
            //     </MDBox>
            //   </Grid>


            //   {businessCategory !== "Others" ? (
            //     <Grid item xs={12} sm={6}>
            //       <MDBox mb={2}>
            //         <FormControl fullWidth error={!!validationErrors.businessCategory}>
            //           <InputLabel id="business-category-label">Business Category</InputLabel>
            //           <Select
            //             labelId="business-category-label"
            //             name="businessCategory"
            //             label="Business Category"
            //             sx={{ height: 45 }}
            //             value={businessCategory || ""}
            //             onChange={handleBusinessCategoryChange}
            //             fullWidth
            //           >
            //             {businessCategoryOptions.length > 0 &&
            //               businessCategoryOptions.map((type) => (
            //                 <MenuItem key={type.id} value={type.business_category}>
            //                   {type.business_category}
            //                 </MenuItem>
            //               ))}
            //             <MenuItem key="Others" value="Others">
            //               Others
            //             </MenuItem>
            //           </Select>
            //           {validationErrors.businessCategory && (
            //             <FormHelperText>{validationErrors.businessCategory}</FormHelperText>
            //           )}
            //         </FormControl>
            //       </MDBox>
            //     </Grid>
            //   ) : (
            //     <Grid item xs={12} sm={6}>
            //       <MDBox margin="normal" fullWidth>
            //         <FormControl fullWidth error={!!validationErrors.others}>
            //           <TextField
            //             id="business_category_others"
            //             type="text"
            //             label="Others"
            //             variant="outlined"
            //             name="others"
            //             value={Input.others || ""}
            //             onChange={handleBusinessInputChange}
            //             fullWidth
            //             InputProps={{
            //               endAdornment: (
            //                 <InputAdornment position="end">
            //                   <IconButton
            //                     onClick={() => {
            //                       // Clear the others text
            //                       setInput((prev) => ({ ...prev, others: "" }));
            //                       // Reset business category selection
            //                       setBusinessCategory("");
            //                     }}
            //                   >
            //                     <ArrowBackIcon />
            //                   </IconButton>
            //                 </InputAdornment>
            //               ),
            //             }}
            //           />
            //           {validationErrors.others && (
            //             <FormHelperText>{validationErrors.others}</FormHelperText>
            //           )}
            //         </FormControl>
            //       </MDBox>
            //     </Grid>
            //   )}

            //   <Grid item xs={12} sm={6} >
            //     <MDBox margin="normal" mb={2}>
            //       <FormControl fullWidth error={!!validationErrors.ownerName}>
            //         <TextField
            //           type="text"
            //           label="Owner Name"
            //           variant="outlined"
            //           name="ownerName"
            //           error={!!validationErrors.ownerName}  // ✅ Apply error to TextField
            //           value={Input.ownerName || ""}
            //           onChange={handleBusinessInputChange}
            //           helperText={validationErrors.ownerName}
            //           fullWidth
            //           className={validationErrors.ownerName ? "errorInput" : ""}
            //           FormHelperTextProps={{
            //             className: validationErrors.ownerName ? "errorMessage" : "",
            //           }}
            //         />
            //       </FormControl>
            //     </MDBox>
            //   </Grid>

            //   {/* Mobile Number Input with Send OTP Button */}
            //   <Grid item xs={12} sm={6}>
            //     <MDBox margin="normal" mb={2}>
            //       <FormControl fullWidth error={!!validationErrors.mobileNumber}>
            //         <TextField
            //           type="tel"
            //           label="Mobile Number"
            //           variant="outlined"
            //           value={mobileNumber}
            //           onChange={handleMobileChange}
            //           fullWidth
            //           error={!!validationErrors.mobileNumber}  // ✅ Apply error to TextField
            //           className={validationErrors.mobileNumber ? "errorInput" : ""}
            //           InputProps={{
            //             endAdornment: otpVerified ? (
            //               <CheckCircleIcon color="success" fontSize="large" />
            //             ) : (
            //               mobileNumber.length === 10 && (
            //                 <MDButton
            //                   onClick={handleSendOtp}
            //                   variant="gradient"
            //                   color="info"
            //                   disabled={mobileNumber.length !== 10 || timer > 0 || !!validationErrors.mobileNumber}
            //                   sx={{

            //                     fontSize: "10px",
            //                     // background: "transparent",
            //                     // color: "inherit",
            //                     boxShadow: "none",
            //                     padding: "4px 8px",
            //                     minWidth: "auto",
            //                   }}
            //                 >
            //                   {!otpSent ? "Send OTP" : timer > 0 ? `${timer}s` : "Resend OTP"}
            //                 </MDButton>
            //               )
            //             ),
            //           }}
            //         />
            //         {/* ✅ Correctly Display the Error Message */}
            //         {validationErrors.mobileNumber && (
            //           <FormHelperText>{validationErrors.mobileNumber}</FormHelperText>
            //         )}
            //       </FormControl>
            //     </MDBox>
            //   </Grid>

            //   {/* OTP Input Field (Only appears after OTP is sent) */}
            //   {otpSent && (
            //     <Grid item xs={12} sm={6} >
            //       <MDBox margin="normal" mb={2}>
            //         <FormControl fullWidth >
            //           <TextField
            //             type="text"
            //             label="Enter OTP"
            //             variant="outlined"
            //             value={otp}
            //             onChange={handleOtpChange}
            //             helperText={otpError}
            //             fullWidth
            //             error={!!otpError}
            //             InputProps={{
            //               endAdornment: (
            //                 <MDButton
            //                   variant="gradient"
            //                   color="info"
            //                   onClick={handleVerifyOtp}
            //                   disabled={otp.length !== 6}
            //                   sx={{
            //                     fontSize: "10px",
            //                     // background: "transparent",
            //                     // color: "inherit",
            //                     boxShadow: "none",
            //                     padding: "4px 8px",
            //                     minWidth: "auto",
            //                   }}
            //                 >
            //                   Verify
            //                 </MDButton>
            //               ),
            //             }}
            //           />

            //         </FormControl>
            //       </MDBox>
            //     </Grid>
            //   )}


            //   <Grid item xs={12} sm={6}>
            //     <MDBox margin="normal" mb={2}>
            //       <FormControl fullWidth error={!!validationErrors.email}> {/* ✅ Apply error here */}
            //         <TextField
            //           type="email"
            //           label="Email"
            //           variant="outlined"
            //           value={email}
            //           onChange={handleEmailChange}
            //           fullWidth
            //           error={!!validationErrors.email}  // ✅ Apply error to TextField
            //           helperText={validationErrors.email}  // ✅ Show error message
            //           InputProps={{
            //             endAdornment: otpVerifiedEmail ? (
            //               <CheckCircleIcon color="success" fontSize="large" />
            //             ) : (
            //               isValidEmail(email) && (
            //                 <MDButton
            //                   onClick={handleEmailSendOtp}
            //                   disabled={!isValidEmail(email) || timerEmail > 0 || !!validationErrors.email}
            //                   variant="gradient"
            //                   color="info"
            //                   sx={{
            //                     fontSize: "10px",
            //                     boxShadow: "none",
            //                     padding: "4px 8px",
            //                     minWidth: "auto",
            //                   }}
            //                 >
            //                   {otpSentEmail ? (timerEmail > 0 ? `(${timerEmail}s)` : "Resend OTP") : "Send OTP"}
            //                 </MDButton>
            //               )
            //             ),
            //           }}
            //         />

            //       </FormControl>
            //     </MDBox>
            //   </Grid>


            //   {/* OTP Input Field (Only appears after OTP is sent) */}
            //   {otpSentEmail && (
            //     <Grid item xs={12} sm={6} >
            //       <MDBox margin="normal" mb={2}>
            //         <FormControl fullWidth >
            //           <TextField
            //             type="text"
            //             label="Enter OTP"
            //             variant="outlined"
            //             value={otpEmail}
            //             onChange={handleEmailOtpChange}
            //             helperText={otpErrorEmail}
            //             fullWidth
            //             error={!!otpErrorEmail}
            //             InputProps={{
            //               endAdornment: (
            //                 <MDButton
            //                   onClick={handleEmailVerifyOtp}
            //                   disabled={otpEmail.length !== 6}
            //                   variant="gradient"
            //                   color="info"
            //                   sx={{
            //                     fontSize: "10px",
            //                     // background: "transparent",
            //                     // color: "inherit",
            //                     boxShadow: "none",
            //                     padding: "4px 8px",
            //                     minWidth: "auto",
            //                   }}
            //                 >
            //                   Verify
            //                 </MDButton>
            //               ),
            //             }}
            //           />

            //         </FormControl>
            //       </MDBox>
            //     </Grid>
            //   )}

            //   <Grid item xs={12} sm={6}>
            //     <MDBox margin="normal" mb={2}>
            //       <FormControl fullWidth error={!!validationErrors.password}>
            //         <TextField
            //           type="password"
            //           label="Password"
            //           variant="outlined"
            //           name="password"
            //           value={Input.password || ""}
            //           onChange={handleBusinessInputChange} // 🔹 Updated function for password validation
            //           fullWidth
            //           error={!!validationErrors.password} // 🔹 Ensures the error state is applied
            //           helperText={validationErrors.password} // 🔹 Shows error message
            //           FormHelperTextProps={{
            //             className: validationErrors.password ? "errorMessage" : "",
            //           }}
            //         />
            //       </FormControl>
            //     </MDBox>
            //   </Grid>

            //   <Grid item xs={12} sm={6} mt={-2}>
            //     <KeywordsInput
            //       keywords={Input.keywords || []}
            //       onChange={(newKeywords) =>
            //         handleBusinessInputChange({ target: { name: "keywords", value: newKeywords } })
            //       }
            //     />
            //   </Grid>

            //   <Grid item xs={12} sm={12}>
            //     <MDBox mb={3} >
            //       <MDButton
            //         type="button"
            //         onClick={handleSaveBusinessDetails}
            //         variant="gradient"
            //         color="info"
            //         disabled={!isFormValid1()}
            //         style={{ marginLeft: "auto" }}
            //       >
            //         Next
            //       </MDButton>

            //     </MDBox>
            //   </Grid>
            // </>
            <>
              <Grid item xs={12} sm={6} mt={1}>
                <MDBox margin="normal" fullWidth>
                  <FormControl fullWidth error={!!validationErrors.businessName}>
                    <TextField
                      id="business-name"
                      name="businessName"
                      type="text"
                      label="Business Name"
                      variant="outlined"
                      value={Input.businessName}
                      onChange={handleBusinessInputChange}
                      fullWidth
                      error={!!validationErrors.businessName} // ✅ Apply error to TextField
                    />
                    {validationErrors.businessName && (
                      <FormHelperText>{validationErrors.businessName}</FormHelperText>
                    )}
                  </FormControl>
                </MDBox>
              </Grid>

              <Grid item xs={12} sm={6} mt={1}>
                <MDBox mb={2}>
                  <FormControl fullWidth>
                    <InputLabel id="business-type-label">Business Type</InputLabel>
                    <Select
                      labelId="business-type-label"
                      name="businessType"
                      value={Input.businessType || ""}
                      onChange={handleBusinessInputChange}
                      label="Business Type" // Label is inside the TextField
                      fullWidth
                      sx={{ height: 45 }}
                    >
                      <MenuItem value="Retail">Retail</MenuItem>
                      <MenuItem value="Wholesale">Wholesale</MenuItem>
                      <MenuItem value="Retail & Wholesale">Retail & Wholesale</MenuItem>
                    </Select>
                  </FormControl>
                </MDBox>
              </Grid>

              {businessCategory !== "Others" ? (
                <Grid item xs={12} sm={6}>
                  <MDBox mb={2}>
                    <FormControl fullWidth error={!!validationErrors.businessCategory}>
                      <InputLabel id="business-category-label">Business Category</InputLabel>
                      <Select
                        labelId="business-category-label"
                        name="businessCategory"
                        label="Business Category"
                        sx={{ height: 45 }}
                        value={businessCategory || ""}
                        onChange={handleBusinessCategoryChange}
                        fullWidth
                      >
                        {businessCategoryOptions.length > 0 &&
                          businessCategoryOptions.map((type) => (
                            <MenuItem key={type.id} value={type.business_category}>
                              {type.business_category}
                            </MenuItem>
                          ))}
                        <MenuItem key="Others" value="Others">
                          Others
                        </MenuItem>
                      </Select>
                      {validationErrors.businessCategory && (
                        <FormHelperText>{validationErrors.businessCategory}</FormHelperText>
                      )}
                    </FormControl>
                  </MDBox>
                </Grid>
              ) : (
                <Grid item xs={12} sm={6}>
                  <MDBox margin="normal" fullWidth>
                    <FormControl fullWidth error={!!validationErrors.others}>
                      <TextField
                        id="business_category_others"
                        type="text"
                        label="Others"
                        variant="outlined"
                        name="others"
                        value={Input.others || ""}
                        onChange={handleBusinessInputChange}
                        fullWidth
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => {
                                  // Clear the others text
                                  setInput((prev) => ({ ...prev, others: "" }));
                                  // Reset business category selection
                                  setBusinessCategory("");
                                }}
                              >
                                <ArrowBackIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                      {validationErrors.others && (
                        <FormHelperText>{validationErrors.others}</FormHelperText>
                      )}
                    </FormControl>
                  </MDBox>
                </Grid>
              )}

              <Grid item xs={12} sm={6}>
                <MDBox margin="normal" mb={2}>
                  <FormControl fullWidth error={!!validationErrors.ownerName}>
                    <TextField
                      type="text"
                      label="Owner Name"
                      variant="outlined"
                      name="ownerName"
                      error={!!validationErrors.ownerName} // ✅ Apply error to TextField
                      value={Input.ownerName || ""}
                      onChange={handleBusinessInputChange}
                      helperText={validationErrors.ownerName}
                      fullWidth
                      className={validationErrors.ownerName ? "errorInput" : ""}
                      FormHelperTextProps={{
                        className: validationErrors.ownerName ? "errorMessage" : "",
                      }}
                    />
                  </FormControl>
                </MDBox>
              </Grid>

              {/* Mobile Number Input with Send OTP Button */}
              <Grid item xs={12} sm={6}>
                <MDBox margin="normal" mb={2}>
                  <FormControl fullWidth error={!!validationErrors.mobileNumber}>
                    <TextField
                      type="tel"
                      label="Mobile Number"
                      variant="outlined"
                      value={mobileNumber}
                      onChange={handleMobileChange}
                      fullWidth
                      error={!!validationErrors.mobileNumber} // ✅ Apply error to TextField
                      className={validationErrors.mobileNumber ? "errorInput" : ""}
                      InputProps={{
                        endAdornment: otpVerified ? (
                          <CheckCircleIcon color="success" fontSize="large" />
                        ) : (
                          mobileNumber.length === 10 && (
                            <MDButton
                              onClick={handleSendOtp}
                              variant="gradient"
                              color="info"
                              disabled={mobileNumber.length !== 10 || timer > 0 || !!validationErrors.mobileNumber}
                              sx={{
                                fontSize: "10px",
                                boxShadow: "none",
                                padding: "4px 8px",
                                minWidth: "auto",
                              }}
                            >
                              {!otpSent ? "Send OTP" : timer > 0 ? `${timer}s` : "Resend OTP"}
                            </MDButton>
                          )
                        ),
                      }}
                    />
                    {/* ✅ Correctly Display the Error Message */}
                    {validationErrors.mobileNumber && (
                      <FormHelperText>{validationErrors.mobileNumber}</FormHelperText>
                    )}
                  </FormControl>
                </MDBox>
              </Grid>

              {/* OTP Input Field (Only appears after OTP is sent) */}
              {otpSent && (
                <Grid item xs={12} sm={6}>
                  <MDBox margin="normal" mb={2}>
                    <FormControl fullWidth>
                      <TextField
                        type="text"
                        label="Enter OTP"
                        variant="outlined"
                        value={otp}
                        onChange={handleOtpChange}
                        helperText={otpError}
                        fullWidth
                        error={!!otpError}
                        InputProps={{
                          endAdornment: (
                            <MDButton
                              variant="gradient"
                              color="info"
                              onClick={handleVerifyOtp}
                              disabled={otp.length !== 6}
                              sx={{
                                fontSize: "10px",
                                boxShadow: "none",
                                padding: "4px 8px",
                                minWidth: "auto",
                              }}
                            >
                              Verify
                            </MDButton>
                          ),
                        }}
                      />
                    </FormControl>
                  </MDBox>
                </Grid>
              )}

              <Grid item xs={12} sm={6}>
                <MDBox margin="normal" mb={2}>
                  <FormControl fullWidth error={!!validationErrors.email}> {/* ✅ Apply error here */}
                    <TextField
                      type="email"
                      label="Email"
                      variant="outlined"
                      value={email}
                      onChange={handleEmailChange}
                      fullWidth
                      error={!!validationErrors.email} // ✅ Apply error to TextField
                      helperText={validationErrors.email} // ✅ Show error message
                    />
                  </FormControl>
                </MDBox>
              </Grid>

              <Grid item xs={12} sm={6}>
                <MDBox margin="normal" >
                  <FormControl fullWidth error={!!validationErrors.password}>
                    <MDInput
                      type={showPassword ? "text" : "password"}
                      label="Password"
                      variant="outlined"
                      name="password"
                      // CHANGE THESE TWO LINES:
                      value={Input.password || ""} // WAS: Inputservices.password
                      onChange={handleBusinessInputChange} // WAS: handleServiceBusinessInputChange
                      helperText={validationErrors.password}
                      fullWidth
                      className={validationErrors.password ? "errorInput" : ""}
                      FormHelperTextProps={{
                        className: validationErrors.password ? "errorMessage" : "",
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => setShowPassword(!showPassword)}
                              onMouseDown={(event) => event.preventDefault()} // Prevents focus change
                              edge="end"
                            >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </MDBox>
              </Grid>
              <Grid item xs={12} sm={6} mt={-2}>
                <KeywordsInput
                  keywords={Input.keywords || []}
                  onChange={(newKeywords) =>
                    handleBusinessInputChange({ target: { name: "keywords", value: newKeywords } })
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <MDBox margin="normal" mb={2}>
                  <FormControl fullWidth>
                    <TextField
                      type="text"
                      label="Referral Code (Optional)"
                      variant="outlined"
                      value={referralCode}
                      onChange={(e) => setReferralCode(e.target.value.trim().toUpperCase())}
                      placeholder="Enter referral code if provided"
                      fullWidth
                    />
                  </FormControl>
                </MDBox>
              </Grid>

              <Grid item xs={12} sm={12}>
                <MDBox mb={3}>
                  <MDButton
                    type="button"
                    onClick={handleSaveBusinessDetails}
                    variant="gradient"
                    color="info"
                    disabled={!isFormValid1()}
                    style={{ marginLeft: "auto" }}
                  >
                    Next
                  </MDButton>
                </MDBox>
              </Grid>
            </>
          )}
          {(getrole === "Services" &&
            <>
              <Grid item xs={12} sm={6} mt={1}>
                <MDBox>
                  <FormControl fullWidth>
                    <InputLabel id="service-type-label">Service Types</InputLabel>
                    <Select
                      labelId="service-type-label"
                      name="serviceType"
                      value={servicetype} // Ensure this is always an array
                      onChange={handleServiceTypeChange}
                      multiple
                      label="Service Types"
                      renderValue={(selected) => (
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, p: 1 }}>
                          {selected.map((value) => (
                            <Chip
                              key={value}
                              label={value}
                              onDelete={() => handleRemoveChip(value)}
                              deleteIcon={<Cancel fontSize="small" />}
                            />
                          ))}
                        </Box>
                      )}
                      sx={{ height: "auto", minHeight: 45 }}
                      fullWidth
                    >
                      {serviceOptions.map((type) => (
                        <MenuItem key={type.id} value={type.service_type}>
                          {type.service_type}
                        </MenuItem>
                      ))}
                    </Select>
                    {validationErrors.serviceType && (
                      <Typography variant="caption" color="error" sx={{ ml: 1 }}>
                        {validationErrors.serviceType}
                      </Typography>
                    )}
                  </FormControl>

                  {/* Checkbox to enable custom service input */}
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={customServiceEnabled}
                        onChange={(e) => setCustomServiceEnabled(e.target.checked)}
                        color="primary"
                      />
                    }
                    label="Add Custom Service"
                  />

                  {/* Custom Service Input - Only Visible When Checkbox is Checked */}
                  {customServiceEnabled && (
                    <TextField
                      variant="outlined"
                      fullWidth
                      placeholder="Enter custom service and press Enter"
                      value={customService}
                      onChange={(e) => setCustomService(e.target.value)}
                      onKeyDown={handleAddCustomService}
                      sx={{ mt: 2 }}
                    />
                  )}
                </MDBox>
              </Grid>

              <Grid item xs={12} sm={6} mt={1}>
                <FormControl fullWidth>
                  <InputLabel id="specializations-label">Specializations</InputLabel>
                  <Select
                    labelId="specializations-label"
                    multiple
                    displayEmpty
                    label="Specializations"
                    sx={{
                      height: "auto",
                      minHeight: 42,
                      maxHeight: 100,
                      overflowY: "auto",
                    }}
                    value={Array.isArray(Inputservices?.subservicecategory) ? Inputservices.subservicecategory : []}

                    onChange={handleservicesdetailsChange}
                    renderValue={(selected) => (
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 0.5,
                          maxHeight: 80,
                          overflowY: "auto",
                          p: 1,
                        }}
                      >
                        {selected.map((value, index) => (
                          <Chip key={index} label={value} onDelete={() => handleRemoveSpecialization(value)} />
                        ))}
                      </Box>
                    )}
                  >
                    {specializations.length > 0 ? (
                      specializations
                        .filter((service) => {
                          console.log("Filtering Specializations for:", service.service_type);
                          return servicetype.includes(service.service_type);
                        })
                        .map((service, index) => (
                          <Box key={index} sx={{ px: 2, py: 1 }}>
                            {/* Service Type as Title */}
                            <Typography variant="h6" sx={{ fontWeight: "bold", px: 1 }}>
                              {service.service_type}
                            </Typography>

                            {/* Specializations List */}
                            {service.service_specializations ? (
                              service.service_specializations.split(",").map((specialization, specIndex) => {
                                const specValue = specialization.trim();
                                return (
                                  <MenuItem key={specIndex} value={specValue} onClick={() => toggleSpecialization(specValue)}>
                                    <Checkbox checked={Inputservices.subservicecategory.includes(specValue)} />
                                    {specValue}
                                  </MenuItem>
                                );
                              })
                            ) : (
                              <MenuItem disabled>No specializations available</MenuItem>
                            )}

                            {/* Add New Specialization Input */}
                            <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                              <TextField
                                size="small"
                                variant="outlined"
                                placeholder="Add new specialization"
                                value={newSpecialization[service.service_type] || ""}
                                onChange={(e) => handleNewSpecializationChange(service.service_type, e.target.value)}
                                sx={{ mr: 1 }}
                              />
                              <MDButton variant="contained" onClick={() => addSpecialization(service.service_type)}>
                                Add
                              </MDButton>
                            </Box>
                          </Box>
                        ))
                    ) : (
                      <MenuItem disabled>No specializations available</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>


              <Grid item xs={12} sm={6}>
                <MDBox margin="normal" mb={2}>
                  <FormControl fullWidth >
                    <MDInput
                      type="text"
                      label="Name"
                      variant="outlined"
                      name="businessName"
                      // value={Input.businessName || ""}
                      value={Inputservices.businessName || ""}
                      onChange={handleServiceBusinessInputChange}
                      helperText={validationErrors.businessName}
                      fullWidth
                      className={validationErrors.businessName ? "errorInput" : ""}
                      FormHelperTextProps={{
                        className: validationErrors.businessName ? "errorMessage" : "",
                      }}
                    />
                  </FormControl>
                </MDBox>
              </Grid>

              <Grid item xs={12} sm={6}>
                <MDBox margin="normal" mb={2}>
                  <FormControl fullWidth >
                    <MDInput
                      type="email"
                      label="Email"
                      variant="outlined"
                      name="email"
                      value={Inputservices.email || ""}
                      onChange={handleServiceBusinessInputChange}
                      helperText={validationErrors.email}
                      fullWidth
                      className={validationErrors.email ? "errorInput" : ""}
                      FormHelperTextProps={{
                        className: validationErrors.email ? "errorMessage" : "",
                      }}
                    />
                  </FormControl>
                </MDBox>
              </Grid>

              {/* Mobile Number Input with Send OTP Button */}
              <Grid item xs={12} sm={6}>
                <MDBox margin="normal">
                  <FormControl fullWidth error={!!validationErrors.mobileNumber}>
                    <MDInput
                      type="tel"
                      label="Mobile Number"
                      variant="outlined"
                      value={mobileNumberService}
                      onChange={handleServiceMobileChange}
                      fullWidth
                      error={!!validationErrors.mobileNumber}
                      InputProps={{
                        endAdornment: otpVerifiedService ? (
                          <CheckCircleIcon color="success" fontSize="large" />
                        ) : (
                          mobileNumberService.length === 10 && (
                            <MDButton
                              onClick={handleServiceSendOtp}
                              disabled={mobileNumberService.length !== 10 || timerService > 0 || !!validationErrors.mobileNumber}
                              variant="gradient"
                              color="info"
                              sx={{
                                fontSize: "10px",
                                boxShadow: "none",
                                padding: "4px 8px",
                                minWidth: "auto",
                              }}
                            >
                              {!otpSentService ? "Send OTP" : timerService > 0 ? `(${timerService}s)` : "Resend OTP"}
                            </MDButton>
                          )
                        ),
                      }}
                    />
                    {validationErrors.mobileNumber && (
                      <FormHelperText>{validationErrors.mobileNumber}</FormHelperText>
                    )}
                  </FormControl>

                </MDBox>
              </Grid>

              {/* OTP Input Field (Only appears after OTP is sent) */}
              {otpSentService && (
                <Grid item xs={12} sm={6}>
                  <MDBox margin="normal" >
                    <FormControl fullWidth error={!!otpErrorService}>
                      <MDInput
                        type="text"
                        label="Enter OTP"
                        variant="outlined"
                        value={otpService}
                        onChange={handleServiceOtpChange}
                        fullWidth
                        error={!!otpErrorService}
                        InputProps={{
                          endAdornment: (
                            <MDButton
                              onClick={handleServiceVerifyOtp}
                              disabled={otpService.length !== 6}
                              variant="gradient"
                              color="info"
                              sx={{
                                fontSize: "10px",
                                boxShadow: "none",
                                padding: "4px 8px",
                                minWidth: "auto",
                              }}
                            >
                              Verify
                            </MDButton>
                          ),
                        }}
                      />
                      {otpErrorService && <FormHelperText>{otpErrorService}</FormHelperText>}
                    </FormControl>

                  </MDBox>
                </Grid>
              )}


              <Grid item xs={12} sm={6}>
                <MDBox margin="normal" >
                  <FormControl fullWidth error={!!validationErrors.password}>
                    <MDInput
                      type={showPasswordService ? "text" : "password"} // <-- CHANGED: Dynamically set type based on state
                      label="Password"
                      variant="outlined"
                      name="password"
                      value={Inputservices.password || ""}
                      onChange={handleServiceBusinessInputChange}
                      helperText={validationErrors.password}
                      fullWidth
                      className={validationErrors.password ? "errorInput" : ""}
                      FormHelperTextProps={{
                        className: validationErrors.password ? "errorMessage" : "",
                      }}
                      InputProps={{ // <-- ADDED: InputProps to include the toggle button
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => setShowPasswordService(!showPasswordService)} // <-- ADDED: Toggles visibility state
                              onMouseDown={(event) => event.preventDefault()} // <-- ADDED: Prevents input blur on icon click
                              edge="end"
                            >
                              {showPasswordService ? <VisibilityOff /> : <Visibility />} {/* <-- ADDED: Conditional icon rendering */}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </FormControl>
                </MDBox>
              </Grid>
              <Grid item xs={12} sm={6}>
                <MDBox margin="normal" mb={2}>
                  <FormControl fullWidth>
                    <TextField
                      type="text"
                      label="Referral Code (Optional)"
                      variant="outlined"
                      value={referralCode}
                      onChange={(e) => setReferralCode(e.target.value.trim().toUpperCase())}
                      placeholder="Enter referral code if provided"
                      fullWidth
                    />
                  </FormControl>
                </MDBox>
              </Grid>

              <KeywordsInput
                label="Service Related Keywords"
                keywords={Inputservices.keywords || []}
                onChange={(newKeywords) =>
                  handleServiceBusinessInputChange({
                    target: { name: "keywords", value: newKeywords },
                  })
                }
              />


              <Grid container spacing={2}>
                {/* Other form elements here */}

                {/* Button placed in a separate row */}
                <Grid item xs={12}>
                  <MDBox display="flex" justifyContent="flex-end" mt={3}>
                    <MDButton
                      type="button"
                      onClick={handleservicesSaveBusinessDetails}
                      variant="gradient"
                      color="info"
                      disabled={!isFormValid || !otpVerifiedService} // Disable until everything is valid
                    >
                      Next
                    </MDButton>
                  </MDBox>
                </Grid>
              </Grid>

            </>)}

        </Grid>


      );
    }

    if (step === 2) {
      // Check if all required fields except GST are filled and error-free
      const isAllFieldsValid =
        Input.accountNumber &&
        Input.ifscCode &&
        Input.accountHolderName &&
        Input.panCardNumber &&
        !validationErrors.accountNumber &&
        !validationErrors.ifscCode &&
        !validationErrors.accountHolderName &&
        !validationErrors.panCardNumber &&
        !validationErrors.bankName &&
        !validationErrors.branchName;

      return (
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <MDBox margin="normal" mb={2}>
              <FormControl fullWidth>
                <TextField
                  type="text"
                  label="Account Number"
                  variant="outlined"
                  name="accountNumber"
                  value={Input.accountNumber || ""}
                  onChange={handleBankDetailsChange}
                  fullWidth
                  helperText={validationErrors.accountNumber}
                  className={validationErrors.accountNumber ? "errorInput" : ""}
                  error={!!validationErrors.accountNumber}
                  FormHelperTextProps={{
                    className: validationErrors.accountNumber ? "errorMessage" : "",
                  }}
                />
              </FormControl>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={6}>
            <MDBox margin="normal" mb={2}>
              <FormControl fullWidth>
                <TextField
                  type="text"
                  label="IFSC Code"
                  variant="outlined"
                  name="ifscCode"
                  value={Input.ifscCode || ""}
                  onChange={handleBankDetailsChange}
                  fullWidth
                  helperText={validationErrors.ifscCode}
                  error={!!validationErrors.ifscCode}
                  className={validationErrors.ifscCode ? "errorInput" : ""}
                  FormHelperTextProps={{
                    className: validationErrors.ifscCode ? "errorMessage" : "",
                  }}
                />
              </FormControl>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={6}>
            <MDBox margin="normal" mb={2}>
              <FormControl fullWidth>
                <TextField
                  type="text"
                  label="Account Holder Name"
                  variant="outlined"
                  name="accountHolderName"
                  placeholder="Provide a name as per passbook"
                  value={Input.accountHolderName || ""}
                  onChange={handleBankDetailsChange}
                  error={!!validationErrors.accountHolderName}
                  fullWidth
                  helperText={validationErrors.accountHolderName}
                  className={validationErrors.accountHolderName ? "errorInput" : ""}
                  FormHelperTextProps={{
                    className: validationErrors.accountHolderName ? "errorMessage" : "",
                  }}
                />
              </FormControl>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={6}>
            <MDBox margin="normal" mb={2}>
              <FormControl fullWidth>
                <TextField
                  type="text"
                  label="Bank Name"
                  variant="outlined"
                  name="bankName"
                  placeholder="Provide a Bank Name"
                  value={Input.bankName || ""}
                  onChange={handleBankDetailsChange}
                  error={!!validationErrors.bankName}
                  fullWidth
                  helperText={validationErrors.bankName}
                  className={validationErrors.bankName ? "errorInput" : ""}
                  FormHelperTextProps={{
                    className: validationErrors.bankName ? "errorMessage" : "",
                  }}
                />
              </FormControl>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={6}>
            <MDBox margin="normal" mb={2}>
              <FormControl fullWidth>
                <TextField
                  type="text"
                  label="Branch Name"
                  variant="outlined"
                  name="branchName"
                  placeholder="Provide a Branch Name"
                  value={Input.branchName || ""}
                  onChange={handleBankDetailsChange}
                  error={!!validationErrors.branchName}
                  fullWidth
                  helperText={validationErrors.branchName}
                  className={validationErrors.branchName ? "errorInput" : ""}
                  FormHelperTextProps={{
                    className: validationErrors.branchName ? "errorMessage" : "",
                  }}
                />
              </FormControl>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={6}>
            <MDBox margin="normal" mb={2}>
              <FormControl fullWidth>
                <TextField
                  type="text"
                  label="PAN Card Number"
                  variant="outlined"
                  name="panCardNumber"
                  value={Input.panCardNumber || ""}
                  onChange={handleBankDetailsChange}
                  error={!!validationErrors.panCardNumber}
                  helperText={validationErrors.panCardNumber}
                  className={validationErrors.panCardNumber ? "errorInput" : ""}
                  FormHelperTextProps={{
                    className: validationErrors.panCardNumber ? "errorMessage" : "",
                  }}
                  fullWidth
                />
              </FormControl>
            </MDBox>
          </Grid>

          {/* Show GST Number only for Vendors */}
          {getrole === "Vendors" && (
            <Grid item xs={12} sm={6}>
              <MDBox margin="normal" mb={2}>
                <FormControl fullWidth>
                  <TextField
                    type="text"
                    label="GST Number (Optional)"
                    variant="outlined"
                    error={!!validationErrors.gstNumber}
                    name="gstNumber"
                    value={Input.gstNumber || ""}
                    onChange={handleBankDetailsChange}
                    helperText={validationErrors.gstNumber}
                    className={validationErrors.gstNumber ? "errorInput" : ""}
                    FormHelperTextProps={{
                      className: validationErrors.gstNumber ? "errorMessage" : "",
                    }}
                    fullWidth
                  />
                </FormControl>
              </MDBox>
            </Grid>
          )}

          {/* Navigation Buttons */}
          <Grid item xs={12}>
            <MDBox display="flex" justifyContent="space-between" mb={3}>
              {/* Back Button */}
              <MDButton
                type="button"
                onClick={handleBackToStep1}
                variant="gradient"
                color="info"
              >
                Back
              </MDButton>

              {/* Next Button for Vendors */}
              {getrole === "Vendors" && (
                <MDButton
                  type="button"
                  onClick={handleBankDetailsSubmit}
                  variant="gradient"
                  color="info"
                  disabled={!isAllFieldsValid} // Disable if any required field is invalid or empty
                >
                  Next
                </MDButton>
              )}

              {/* Next Button for Services */}
              {getrole === "Services" && (
                <MDButton
                  type="button"
                  onClick={handleBankDetailsServicesSubmit}
                  variant="gradient"
                  color="info"
                  disabled={!isAllFieldsValid} // Disable if any required field is invalid or empty
                >
                  Next
                </MDButton>
              )}
            </MDBox>
          </Grid>
        </Grid>
      );
    }

    if (step === 3) {
      return (
        <Grid container spacing={2} justifyContent="center">
          {/* Vendor Photo */}
          <Grid item xs={12} sm={6} textAlign="left">
            <MDBox mb={2} display="flex" flexDirection="column" alignItems="flex-start">
              <MDButton variant="gradient" color="info" component="label" sx={{ mb: 1 }} >
                Vendor Photo Copy
                <input type="file" accept="image/*" hidden onChange={(e) => handleSingleFileChange(e, 'vendorPhoto', setFiles, setError)} />
              </MDButton>

              {/* Display Selected Image */}
              {files.vendorPhoto && (
                <img
                  src={URL.createObjectURL(files.vendorPhoto)}
                  alt="Vendor"
                  width="100"
                  height="100"
                  style={{ marginBottom: 10, display: 'block' }}
                />
              )}

              {/* No Image Selected Message (Only If No Error) */}
              {!files.vendorPhoto && !errors.vendorPhoto && (
                <Typography mt={1} variant="caption" color="gray">
                  <InsertPhotoIcon /> No file selected
                </Typography>
              )}

              {/* Error Message */}
              {errors.vendorPhoto && (
                <Typography mt={1} variant="caption" color="red">
                  {errors.vendorPhoto}
                </Typography>
              )}
            </MDBox>
          </Grid>

          {/* Shop Photo */}
          <Grid item xs={12} sm={6} textAlign="left">
            <MDBox mb={2} display="flex" flexDirection="column" alignItems="flex-start">
              <MDButton variant="gradient" color="info" component="label" sx={{ mb: 1 }}>
                Shop Photocopy with NameBoard
                <input type="file" accept="image/*" hidden onChange={(e) => handleSingleFileChange(e, 'shopPhoto', setFiles, setError)} />
              </MDButton>

              {/* Display Selected Image */}
              {files.shopPhoto && (
                <img
                  src={URL.createObjectURL(files.shopPhoto)}
                  alt="Shop"
                  width="100"
                  height="100"
                  style={{ marginBottom: 10, display: 'block' }}
                />
              )}

              {/* No Image Selected Message (Only If No Error) */}
              {!files.shopPhoto && !errors.shopPhoto && (
                <Typography mt={1} variant="caption" color="gray">
                  <InsertPhotoIcon /> No file selected
                </Typography>
              )}

              {/* Error Message */}
              {errors.shopPhoto && (
                <Typography mt={1} variant="caption" color="red">
                  {errors.shopPhoto}
                </Typography>
              )}
            </MDBox>
          </Grid>

          {/* GPS Photo */}
          <Grid item xs={12} sm={6} textAlign="left">
            <MDBox mb={2} display="flex" flexDirection="column" alignItems="flex-start">
              <MDButton variant="gradient" color="info" component="label" sx={{ mb: 1 }}>
                Shop's GPS Photo Copy (Optional)
                <input type="file" accept="image/*" hidden onChange={(e) => handleSingleFileChange(e, 'gpsPhoto', setFiles, setError)} />
              </MDButton>

              {/* Display Selected Image */}
              {files.gpsPhoto && (
                <img
                  src={URL.createObjectURL(files.gpsPhoto)}
                  alt="GPS"
                  width="100"
                  height="100"
                  style={{ marginBottom: 10, display: 'block' }}
                />
              )}

              {/* No Image Selected Message (Only If No Error) */}
              {!files.gpsPhoto && !errors.gpsPhoto && (
                <Typography mt={1} variant="caption" color="gray">
                  <InsertPhotoIcon /> No file selected
                </Typography>
              )}

              {/* Error Message */}
              {errors.gpsPhoto && (
                <Typography mt={1} variant="caption" color="red">
                  {errors.gpsPhoto}
                </Typography>
              )}
            </MDBox>
          </Grid>


          {/* Multiple Masked Aadhar Upload */}
          <Grid item xs={12} sm={6} textAlign="left">
            <MDBox mb={2} display="flex" flexDirection="column" alignItems="flex-start">
              <MDButton variant="gradient" color="info" component="label" sx={{ mb: 1 }}>
                Gov ID Proof (Front and Back)
                <input type="file" accept="image/*" multiple hidden onChange={(e) => handleMultipleFileChange1(e, 'userProofDoc', setFiles, setError)} />

              </MDButton>

              {/* Display Multiple Selected Files */}
              {files.userProofDoc?.length > 0 && (
                <Grid container spacing={1}>
                  {files.userProofDoc.map((doc, index) => (
                    <Grid item key={index}>
                      <img
                        src={URL.createObjectURL(doc)}
                        alt="Aadhar"
                        width="100"
                        height="100"
                        style={{ marginBottom: 10, display: 'block' }}
                      />
                    </Grid>
                  ))}
                </Grid>
              )}

              {/* No Image Selected Message (Only If No Error) */}
              {!files.userProofDoc?.length && !errors.userProofDoc && (
                <Typography mt={1} variant="caption" color="gray">
                  <InsertPhotoIcon /> No file selected
                </Typography>
              )}

              {/* Error Message */}
              {errors.userProofDoc && (
                <Typography mt={1} variant="caption" color="red">
                  {errors.userProofDoc}
                </Typography>
              )}
            </MDBox>
          </Grid>

          {/* Buttons Row */}
          <Grid item xs={12}>
            <MDBox display="flex" justifyContent="space-between" mb={3}>
              <MDButton type="button" onClick={handleBackToStep2} variant="gradient" color="info">
                Back
              </MDButton>
              <MDButton
                type="button"
                onClick={handleImageDetailsSubmit}
                variant="gradient"
                color="info"
                disabled={!files.vendorPhoto || !files.shopPhoto || !files.userProofDoc?.length}
              >
                Sign Up
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>
      );
    }

    if (step === 4) {
      return (
        <Grid container spacing={3}>


          <Grid item xs={12} sm={12}>
            <MDBox margin="normal" >
              <FormControl fullWidth>
                <MDInput
                  type="text"
                  label="Shop / Work Address"
                  variant="outlined"
                  name="operatinglocation"
                  // value={sameAddress ? Inputservices.homeaddress : Inputservices.operatinglocation || ""}
                  onChange={handleservicesdetailsChange}
                  fullWidth
                  helperText={validationErrors.operatinglocation}
                  className={validationErrors.operatinglocation ? "errorInput" : ""}
                  FormHelperTextProps={{
                    className: validationErrors.operatinglocation ? "errorMessage" : "",
                  }}
                  multiline
                  rows={2}
                  placeholder="Enter Shop/Work Address with Pincode"
                />
              </FormControl>
            </MDBox>
          </Grid>

          {/* Checkbox for copying address */}
          <Grid item xs={12} display="flex" justifyContent="left">
            <FormControlLabel
              control={
                <Checkbox
                  checked={sameAddress}
                  onChange={handleSameAddressChange}
                  color="primary"
                  sx={{
                    '& .MuiSvgIcon-root': {
                      color: '#f44336',
                    },
                    '&:hover .MuiSvgIcon-root': {
                      color: '#e53935',
                    },
                    '&.Mui-checked .MuiSvgIcon-root': {
                      color: '#1976d2',
                    },
                  }}
                />
              }
              label="Same as Shop / Work Address"
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <MDBox margin="normal" >
              <FormControl fullWidth>
                <MDInput
                  type="text"
                  label="Home Address"
                  variant="outlined"
                  name="homeaddress"
                  value={sameAddress ? Inputservices.operatinglocation : Inputservices.homeaddress || ""}
                  onChange={handleservicesdetailsChange}
                  fullWidth
                  helperText={validationErrors.homeaddress}
                  className={validationErrors.homeaddress ? "errorInput" : ""}
                  FormHelperTextProps={{
                    className: validationErrors.homeaddress ? "errorMessage" : "",
                  }}
                  multiline
                  rows={2}
                  placeholder="Enter Home Location with Pincode."
                  disabled={sameAddress}
                />
              </FormControl>
            </MDBox>
          </Grid>

          <Grid item xs={12} sm={12}>
            <MDBox margin="normal" mb={2}>
              <FormControl fullWidth>
                <MDInput
                  type="number"
                  label="Experience (Years)"
                  variant="outlined"
                  name="experiance"
                  value={Inputservices.experiance || ""}
                  onChange={handleservicesdetailsChange}
                  helperText={validationErrors.experiance}
                  className={validationErrors.experiance ? "errorInput" : ""}
                  FormHelperTextProps={{
                    className: validationErrors.experiance ? "errorMessage" : "",
                  }}
                  fullWidth
                />
              </FormControl>
            </MDBox>
          </Grid>
          <Grid item xs={12} sm={12}>

            <MDBox margin="normal" mb={2}>
              <FormControl fullWidth>
                <MDInput
                  type="text"
                  label="Details" handleservicesdetailsChange
                  variant="outlined"
                  name="details"
                  value={Inputservices.details || ""}
                  onChange={handleservicesdetailsChange}
                  fullWidth
                  helperText={validationErrors.details}
                  className={validationErrors.details ? "errorInput" : ""}
                  FormHelperTextProps={{
                    className: validationErrors.details ? "errorMessage" : "",
                  }}
                  multiline
                  rows={2} // Adjust the number of rows as per your requirement
                  placeholder="Enter details including Description and about services"
                />
              </FormControl>
            </MDBox>

          </Grid>


          {/* Navigation Buttons */}
          <Grid item xs={12}>
            <MDBox display="flex" justifyContent="space-between" mb={3}>
              {/* Back Button */}
              <MDButton
                type="button"
                onClick={handleBackToStep2}
                variant="gradient"
                color="info"
              >
                Back
              </MDButton>

              {/* Edit Mode Button */}
              {isEditingStep2 ? (
                <MDButton
                  type="button"
                  onClick={handleEditModeToggle}
                  variant="gradient"
                  color="info"
                >
                  Edit
                </MDButton>
              ) : (
                /* Next Button (Save the form and proceed to next step) */
                <MDButton
                  type="button"
                  onClick={handleservicestep4}
                  variant="gradient"
                  color="info"
                  disabled={
                    !Inputservices.operatinglocation ||
                    (!sameAddress && !Inputservices.homeaddress) ||
                    !Inputservices.experiance ||
                    !Inputservices.details ||
                    !!validationErrors.operatinglocation ||
                    (!sameAddress && !!validationErrors.homeaddress) ||
                    !!validationErrors.experiance ||
                    !!validationErrors.details
                  }
                >
                  Next
                </MDButton>
              )}
            </MDBox>

          </Grid>

        </Grid>
      );
    }

    if (step === 6) {
      return (
        <Grid container spacing={2} justifyContent="center">
          {/* Profile Image */}
          <Grid item xs={6} textAlign="left">
            <MDBox mb={2}>
              <MDButton variant="gradient" color="info" component="label">
                Profile Image
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={(e) => handleFileChangeservice(e, setProfilephoto, "profilephoto")}
                />
              </MDButton>
              {!profilephoto && (
                <Typography mt={1} variant="caption" color="gray" display="block">
                  <InsertPhotoIcon /> No file selected
                </Typography>
              )}
              {profilephoto && (
                <img
                  src={URL.createObjectURL(profilephoto)}
                  alt="Profile"
                  width="100"
                  height="100"
                  style={{ marginTop: 10, display: "block" }}
                />
              )}
              {fileErrors.profilephoto && (
                <Typography variant="caption" color="error">
                  {fileErrors.profilephoto}
                </Typography>
              )}
            </MDBox>
          </Grid>

          {/* ID Proof (Multiple) */}
          <Grid item xs={6} textAlign="left">
            <MDBox mb={2}>
              <MDButton variant="gradient" color="info" component="label">
                Gov ID Proof (Front and Back)
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  hidden
                  onChange={(e) => handleMultipleFileChange(e, setIDPhoto, "idphoto")}
                />
              </MDButton>
              {idphoto.length === 0 && (
                <Typography mt={1} variant="caption" color="gray" display="block">
                  <InsertPhotoIcon /> No file selected
                </Typography>
              )}
              {idphoto.length > 0 && (
                <Grid container spacing={1}>
                  {idphoto.map((doc, index) => (
                    <Grid item key={index}>
                      <img
                        src={URL.createObjectURL(doc)}
                        alt="ID Proof"
                        width="100"
                        height="100"
                        style={{ marginTop: 10, display: "block" }}
                      />
                    </Grid>
                  ))}
                </Grid>
              )}
              {fileErrors.idphoto && (
                <Typography variant="caption" color="error">
                  {fileErrors.idphoto}
                </Typography>
              )}
            </MDBox>
          </Grid>

          {/* Experience Certificate (Multiple) */}
          <Grid item xs={6} textAlign="left">
            <MDBox mb={2}>
              <MDButton variant="gradient" color="info" component="label">
                Experience Certificate
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  hidden
                  onChange={(e) => handleMultipleFileChange(e, setExperienceCertificates, "experienceCertificates")}
                />
              </MDButton>
              {experienceCertificates.length === 0 && (
                <Typography mt={1} variant="caption" color="gray" display="block">
                  <InsertPhotoIcon /> No file selected
                </Typography>
              )}
              {experienceCertificates.length > 0 && (
                <Grid container spacing={1}>
                  {experienceCertificates.map((doc, index) => (
                    <Grid item key={index}>
                      <img
                        src={URL.createObjectURL(doc)}
                        alt="Experience"
                        width="100"
                        height="100"
                        style={{ marginTop: 10, display: "block" }}
                      />
                    </Grid>
                  ))}
                </Grid>
              )}
              {fileErrors.experienceCertificates && (
                <Typography variant="caption" color="error">
                  {fileErrors.experienceCertificates}
                </Typography>
              )}
            </MDBox>
          </Grid>

          {/* Home / Work GPS */}
          <Grid item xs={6} textAlign="left">
            <MDBox mb={2}>
              <MDButton variant="gradient" color="info" component="label">
                Work / Home Place GPS(Optional)
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={(e) => handleFileChangeservice(e, setWorkPlaceGps, "workPlaceGps")}
                />
              </MDButton>
              {!workPlaceGps && (
                <Typography mt={1} variant="caption" color="gray" display="block">
                  <InsertPhotoIcon /> No file selected
                </Typography>
              )}
              {workPlaceGps && (
                <img
                  src={URL.createObjectURL(workPlaceGps)}
                  alt="GPS"
                  width="100"
                  height="100"
                  style={{ marginTop: 10, display: "block" }}
                />
              )}
              {fileErrors.workPlaceGps && (
                <Typography variant="caption" color="error">
                  {fileErrors.workPlaceGps}
                </Typography>
              )}
            </MDBox>
          </Grid>

          {/* Navigation Buttons */}
          <Grid item xs={12}>
            <MDBox display="flex" justifyContent="space-between" mb={3}>
              <MDButton type="button" onClick={handleBackToStep6} variant="gradient" color="info">
                Back
              </MDButton>

              <MDButton
                type="button"
                onClick={handleServiceReviewDetails}
                variant="gradient"
                color="info"
                disabled={
                  !profilephoto ||
                  idphoto.length === 0 ||
                  experienceCertificates.length === 0 ||
                  Object.values(fileErrors).some((err) => err !== "")
                }
              >
                Sign Up
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>

      );
    }
    if (step === 8) {
      return (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MDTypography variant="h5" align="center" gutterBottom sx={{ fontSize: 20 }}>
              Review Your Details
            </MDTypography>
          </Grid>

          {/* Business Details */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" gutterBottom sx={{ fontSize: 15 }}>
              Business Details
            </Typography>
            <Box mb={2} p={2} border="1px solid #e0e0e0" borderRadius={2}>
              {[
                {
                  icon: <Business fontSize="small" style={iconStyle} />,
                  label: "Business Name",
                  value: Input.businessName,
                },
                {
                  icon: <Category fontSize="small" style={iconStyle} />,
                  label: "Business Type",
                  value: Input.businessType,
                },
                {
                  icon: <Category fontSize="small" style={iconStyle} />,
                  label: "Business Category",
                  value: businessCategory === "Others" ? Input.others : businessCategory,
                },
                {
                  icon: <Person fontSize="small" style={iconStyle} />,
                  label: "Owner Name",
                  value: Input.ownerName,
                },
                {
                  icon: <Phone fontSize="small" style={iconStyle} />,
                  label: "Mobile Number",
                  value: mobileNumber,
                },
                {
                  icon: <Email fontSize="small" style={iconStyle} />,
                  label: "Email",
                  value: email,
                },
                {
                  icon: <Email fontSize="small" style={iconStyle} />,
                  label: "Keywords",
                  value: Input.keywords.join(","),
                },
                {
                  icon: <Person fontSize="small" style={iconStyle} />,
                  label: "Referral Code",
                  value: referralCode || "Not Provided",
                },

              ].map((item, index) => (
                <Typography
                  key={index}
                  variant="body2"
                  mb={1}
                  display="flex"
                  alignItems="center"
                  sx={{ fontSize: 13, flexWrap: 'wrap' }}
                >
                  {item.icon}
                  <strong style={{ marginLeft: 4 }}>{item.label}:</strong>&nbsp;{item.value}
                </Typography>
              ))}
            </Box>
          </Grid>

          {/* Bank Details */}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" gutterBottom sx={{ fontSize: 15 }}>
              Bank Details
            </Typography>
            <Box mb={2} p={2} border="1px solid #e0e0e0" borderRadius={2}>
              {[
                {
                  icon: <AccountBalance fontSize="small" style={iconStyle} />,
                  label: "Account Number",
                  value: Input.accountNumber,
                },
                {
                  icon: <CreditCard fontSize="small" style={iconStyle} />,
                  label: "IFSC Code",
                  value: Input.ifscCode,
                },
                {
                  icon: <AccountBox fontSize="small" style={iconStyle} />,
                  label: "Account Holder Name",
                  value: Input.accountHolderName,
                },
                {
                  icon: <AssignmentInd fontSize="small" style={iconStyle} />,
                  label: "Bank Name",
                  value: Input.bankName,
                },
                {
                  icon: <AssignmentInd fontSize="small" style={iconStyle} />,
                  label: "Branch Name",
                  value: Input.branchName,
                },
                {
                  icon: <AssignmentInd fontSize="small" style={iconStyle} />,
                  label: "PAN Card Number",
                  value: Input.panCardNumber,
                },
                {
                  icon: <LocalAtm fontSize="small" style={iconStyle} />,
                  label: "GST Number",
                  value: Input.gstNumber,
                },
              ].map((item, index) => (
                <Typography
                  key={index}
                  variant="body2"
                  mb={1}
                  display="flex"
                  alignItems="center"
                  sx={{ fontSize: 13, flexWrap: 'wrap' }}
                >
                  {item.icon}
                  <strong style={{ marginLeft: 4 }}>{item.label}:</strong>&nbsp;{item.value}
                </Typography>
              ))}
            </Box>
          </Grid>

          {/* Uploaded Images */}
          <Grid container spacing={2}>
            {files.vendorPhoto && (
              <Grid item xs={12} sm={6} md={3}>
                <MDBox mb={2} textAlign="center">
                  <MDTypography variant="body2" gutterBottom sx={{ fontSize: 13 }}>
                    Vendor Photo
                  </MDTypography>
                  <img
                    src={URL.createObjectURL(files.vendorPhoto)}
                    alt="Vendor"
                    style={{ width: '100%', maxHeight: '120px', objectFit: 'contain', borderRadius: '8px' }}
                  />
                </MDBox>
              </Grid>
            )}
            {files.shopPhoto && (
              <Grid item xs={12} sm={6} md={3}>
                <MDBox mb={2} textAlign="center">
                  <MDTypography variant="body2" gutterBottom sx={{ fontSize: 13 }}>
                    Shop Photo
                  </MDTypography>
                  <img
                    src={URL.createObjectURL(files.shopPhoto)}
                    alt="Shop"
                    style={{ width: '100%', maxHeight: '120px', objectFit: 'contain', borderRadius: '8px' }}
                  />
                </MDBox>
              </Grid>
            )}
            {files.gpsPhoto && (
              <Grid item xs={12} sm={6} md={3}>
                <MDBox mb={2} textAlign="center">
                  <MDTypography variant="body2" gutterBottom sx={{ fontSize: 13 }}>
                    GPS Photo
                  </MDTypography>
                  <img
                    src={URL.createObjectURL(files.gpsPhoto)}
                    alt="GPS"
                    style={{ width: '100%', maxHeight: '120px', objectFit: 'contain', borderRadius: '8px' }}
                  />
                </MDBox>
              </Grid>
            )}
            {files.userProofDoc && files.userProofDoc.length > 0 && (
              <Grid item xs={12}>
                <MDBox mb={1} textAlign="left">
                  <MDTypography variant="subtitle1" gutterBottom sx={{ fontSize: 15 }}>
                    Gov ID Proof (Front and Back)
                  </MDTypography>
                </MDBox>
                <Grid container spacing={2}>
                  {files.userProofDoc.map((doc, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                      <MDBox mb={2} textAlign="center">
                        <img
                          src={URL.createObjectURL(doc)}
                          alt={`Masked Aadhar ${index + 1}`}
                          style={{ width: '100%', maxHeight: '120px', objectFit: 'contain', borderRadius: '8px' }}
                        />
                      </MDBox>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            )}
          </Grid>

          {/* Navigation Buttons */}
          <Grid item xs={12}>
            <MDBox display="flex" justifyContent="space-between" mb={3}>
              <MDButton
                type="button"
                onClick={handleBackToStep4}
                variant="gradient"
                color="info"
                sx={{ fontSize: 13, padding: "6px 18px" }}
              >
                Back
              </MDButton>
              <MDButton
                type="button"
                onClick={() => setShowTermsModal(true)}
                variant="gradient"
                color="info"
                sx={{ fontSize: 13, padding: "6px 18px" }}
              >
                Submit
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>

      );
    }
    if (step === 9) {
      return (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDTypography variant="h5" align="center" gutterBottom component="div" sx={{ fontSize: 20 }}>
              Review Your Details
            </MDTypography>
          </Grid>

          {/* Service and Bank Details */}
          <Grid container spacing={2}>
            {/* Bank Details First */}
            <Grid item xs={12} md={6}>
              <Box component="div" fontSize={15} fontWeight="500" mb={1}>
                Bank Details
              </Box>
              <MDBox mb={2} p={2} border="1px solid #e0e0e0" borderRadius="8px">
                {[{
                  icon: <AccountBalance fontSize="small" style={iconStyle} />, label: "Account Number", value: Input.accountNumber
                }, {
                  icon: <CreditCard fontSize="small" style={iconStyle} />, label: "IFSC Code", value: Input.ifscCode
                }, {
                  icon: <Person fontSize="small" style={iconStyle} />, label: "Account Holder Name", value: Input.accountHolderName
                }, {
                  icon: <CreditCard fontSize="small" style={iconStyle} />, label: "Bank Name", value: Input.bankName
                }, {
                  icon: <CreditCard fontSize="small" style={iconStyle} />, label: "Branch Name", value: Input.branchName
                }, {
                  icon: <Payment fontSize="small" style={iconStyle} />, label: "PAN Card Number", value: Input.panCardNumber
                }].map((item, index) => (
                  <Box key={index} display="flex" alignItems="center" mb={1} sx={{ fontSize: 13 }}>
                    {item.icon}
                    <strong style={{ marginLeft: 4, marginRight: 4 }}>{item.label}:</strong>{item.value}
                  </Box>
                ))}
              </MDBox>
            </Grid>

            {/* Service Details Second */}
            <Grid item xs={12} md={6}>
              <Box component="div" fontSize={15} fontWeight="500" mb={1}>
                Service Details
              </Box>
              <MDBox mb={2} p={2} border="1px solid #e0e0e0" borderRadius="8px">
                <Box display="flex" alignItems="center" mb={1} sx={{ fontSize: 13 }}>
                  <Category fontSize="small" style={iconStyle} />
                  <strong style={{ marginLeft: 4 }}>Service Type:</strong>
                </Box>
                {Array.isArray(servicetype) ? servicetype.map((type, index) => (
                  <Box key={index} ml={3} mb={0.5} sx={{ fontSize: 13 }}>{index + 1}. {type}</Box>
                )) : (
                  <Box ml={3} sx={{ fontSize: 13 }}>{servicetype}</Box>
                )}

                <Box display="flex" alignItems="center" mt={1} mb={1} sx={{ fontSize: 13 }}>
                  <Category fontSize="small" style={iconStyle} />
                  <strong style={{ marginLeft: 4 }}>Specializations:</strong>
                </Box>
                {Array.isArray(Inputservices.subservicecategory) ? Inputservices.subservicecategory.map((category, index) => (
                  <Box key={index} ml={3} mb={0.5} sx={{ fontSize: 13 }}>{index + 1}. {category}</Box>
                )) : (
                  <Box ml={3} sx={{ fontSize: 13 }}>{Inputservices.subservicecategory}</Box>
                )}

                {[{
                  icon: <Business fontSize="small" style={iconStyle} />, label: "Name", value: Inputservices.businessName
                }, {
                  icon: <Phone fontSize="small" style={iconStyle} />, label: "Mobile Number", value: mobileNumberService
                }, {
                  icon: <Email fontSize="small" style={iconStyle} />, label: "Email", value: Inputservices.email
                }, {
                  icon: <Person fontSize="small" style={iconStyle} />, label: "Experience (Years)", value: Inputservices.experiance
                }, {
                  icon: <Category fontSize="small" style={iconStyle} />, label: "Details", value: Inputservices.details
                }, {
                  icon: <LocationOn fontSize="small" style={iconStyle} />, label: "Operating Location", value: Inputservices.operatinglocation
                }, {
                  icon: <LocationOn fontSize="small" style={iconStyle} />, label: "Home Address", value: Inputservices.homeaddress
                }, {
                  icon: <LocationOn fontSize="small" style={iconStyle} />, label: "Keywords", value: (Inputservices.keywords || []).join(", ")
                },
                {
                  icon: <Person fontSize="small" style={iconStyle} />,
                  label: "Referral Code",
                  value: referralCode || "Not Provided",
                },
                ].map((item, index) => (
                  <Box key={index} display="flex" alignItems="center" mb={1} sx={{ fontSize: 13 }}>
                    {item.icon}
                    <strong style={{ marginLeft: 4, marginRight: 4 }}>{item.label}:</strong>{item.value}
                  </Box>
                ))}
              </MDBox>
            </Grid>
          </Grid>

          {/* Uploaded Images */}
          <Grid item xs={12}>
            <Box fontSize={15} fontWeight="500" mb={1}>Uploaded Images</Box>
            <MDBox display="flex" flexWrap="wrap" gap={2} mb={2}>
              {profilephoto && (
                <MDBox textAlign="center" width="23%">
                  <Box fontSize={13} mb={1}>Profile Photo</Box>
                  <img src={URL.createObjectURL(profilephoto)} alt="Profile" style={{ width: '100%', height: '100px', objectFit: 'cover', borderRadius: '8px' }} />
                </MDBox>
              )}
              {workPlaceGps && (
                <MDBox textAlign="center" width="23%">
                  <Box fontSize={13} mb={1}>Work Place GPS</Box>
                  <img src={URL.createObjectURL(workPlaceGps)} alt="Work Place GPS" style={{ width: '100%', height: '100px', objectFit: 'cover', borderRadius: '8px' }} />
                </MDBox>
              )}
            </MDBox>

            {idphoto && idphoto.length > 0 && (
              <Box mb={2}>
                <Box fontSize={15} fontWeight="500" mb={1}>Gov ID Proof (Front and Back)</Box>
                <Grid container spacing={2}>
                  {idphoto.map((doc, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                      <MDBox textAlign="center">
                        <img src={URL.createObjectURL(doc)} alt={`ID Proof ${index + 1}`} style={{ width: '100%', height: '100px', objectFit: 'cover', borderRadius: '8px' }} />
                      </MDBox>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}

            {experienceCertificates && experienceCertificates.length > 0 && (
              <Box mb={2}>
                <Box fontSize={15} fontWeight="500" mb={1}>Experience Certificates</Box>
                <Grid container spacing={2}>
                  {experienceCertificates.map((doc, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                      <MDBox textAlign="center">
                        <img src={URL.createObjectURL(doc)} alt={`Experience Certificate ${index + 1}`} style={{ width: '100%', height: '100px', objectFit: 'cover', borderRadius: '8px' }} />
                      </MDBox>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}

          </Grid>

          {/* Navigation Buttons */}
          <Grid item xs={12}>
            <MDBox display="flex" justifyContent="space-between" mb={3}>
              <MDButton
                type="button"
                onClick={handleBackToStep8}
                variant="gradient"
                color="info"
                sx={{ fontSize: 13, px: 3, py: 1 }}
              >
                Back
              </MDButton>
              <MDButton
                type="button"
                onClick={() => setShowTermsModal(true)} // ⬅️ Move to payment step
                variant="gradient"
                color="info"
                sx={{ fontSize: 13, px: 3, py: 1 }}
              >
                Proceed to Pay
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>
      );
    }

    // STEP 10: Payment
    if (step === 10) {
      return (
        <Grid container spacing={3}>
          {/* Section Heading */}
          <Grid item xs={12}>
            <MDTypography
              variant="h4"
              align="center"
              gutterBottom
              sx={{
                fontWeight: 'bold',
                fontSize: 26,
                color: '#1976d2',
                textTransform: 'uppercase',
                letterSpacing: 1,
              }}
            >
              Make Payment
            </MDTypography>
          </Grid>

          {/* Coupon Input & Apply Button */}
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Enter Coupon Code"
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
              variant="outlined"
              size="medium"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '10px',
                },
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <MDButton
              variant="contained"
              color="info"
              onClick={validateCoupon}
              sx={{
                padding: '12px 24px',
                borderRadius: '10px',
                fontWeight: 'bold',
                fontSize: '15px',
                boxShadow: '0 6px 16px rgba(23, 162, 184, 0.3)',
                '&:hover': {
                  boxShadow: '0 8px 20px rgba(23, 162, 184, 0.4)',
                },
              }}
            >
              Apply Coupon
            </MDButton>
          </Grid>

          {/* Payment Plan Cards */}
          {paymentPlans.length > 0 ? (
            paymentPlans.map((plan, index) => {
              const finalAmount = validCoupon
                ? getDiscountedAmount(plan.total_amount)
                : plan.total_amount;

              return (
                <Grid item xs={12} key={index}>
                  <MDBox
                    sx={{
                      border: '2px solid',
                      borderColor: validCoupon ? '#4CAF50' : '#E0E0E0',
                      borderRadius: '16px',
                      p: 3,
                      display: 'flex',
                      flexDirection: { xs: 'column', sm: 'row' },
                      justifyContent: 'space-between',
                      alignItems: { xs: 'flex-start', sm: 'center' },
                      gap: 3,
                      transition: 'all 0.3s ease-in-out',
                      boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
                      background: 'linear-gradient(to right, #f7f9fc, #ffffff)',
                      position: 'relative',
                    }}
                  >
                    {/* Discount Badge */}
                    {validCoupon && (
                      <MDBox
                        sx={{
                          position: 'absolute',
                          top: 0,
                          right: 0,
                          backgroundColor: '#4CAF50',
                          color: 'white',
                          px: 2,
                          py: 0.5,
                          borderBottomLeftRadius: '12px',
                          fontSize: '0.8rem',
                          fontWeight: 'bold',
                        }}
                      >
                        Discount Applied!
                      </MDBox>
                    )}

                    {/* Plan Info */}
                    <Box sx={{ flexGrow: 1 }}>
                      <Typography variant="h6" fontWeight="bold">
                        {plan.name} — ₹{plan.total_amount}
                      </Typography>

                      {validCoupon && (
                        <>
                          <Typography sx={{ color: "#388e3c", fontWeight: "bold" }}>
                            Discounted Price: ₹{finalAmount} ({discount}% OFF)
                          </Typography>
                          <Typography sx={{ textDecoration: "line-through", fontSize: 13 }}>
                            Original Price: ₹{plan.total_amount}
                          </Typography>
                        </>
                      )}

                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        Validity: <strong>{plan.validity_days} days</strong>
                      </Typography>

                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: 14, lineHeight: 1.5 }}>
                        {plan.description}
                      </Typography>

                      {getrole === "Vendors" && (
                        <>
                          <Typography variant="body2" sx={{ fontSize: 13, mt: 1 }}>
                            🔔 Notifications: <strong>{plan.no_of_notifications}</strong>
                          </Typography>

                          <Typography variant="body2" sx={{ fontSize: 13 }}>
                            🖼️ Images Upload: <strong>{plan.total_images_allowed}</strong>
                          </Typography>

                          {plan.total_videos_allowed !== undefined && (
                            <Typography variant="body2" sx={{ fontSize: 13 }}>
                              🎥 Videos Upload: <strong>{plan.total_videos_allowed}</strong>
                            </Typography>
                          )}
                        </>
                      )}

                    </Box>

                    {/* Choose Plan Button */}
                    <MDButton
                      variant="gradient"
                      color="success"
                      onClick={() => {
                        if (getrole === "Services") {
                          handleSubmitservices({
                            ...plan,
                            discountedAmount: finalAmount,
                            couponCode: validCoupon ? couponCode : null,
                          });
                        }
                        if (getrole === "Vendors") {
                          handleSubmit({
                            ...plan,
                            discountedAmount: finalAmount,
                            no_of_notifications: plan.no_of_notifications,
                            total_images_allowed: plan.total_images_allowed,
                            couponCode: validCoupon ? couponCode : null,
                          });

                        }
                      }}
                      sx={{
                        minWidth: { xs: '100%', sm: '160px' },
                        py: 1.5,
                        fontSize: '15px',
                        fontWeight: 'bold',
                        borderRadius: '10px',
                        boxShadow: '0 6px 14px rgba(76, 175, 80, 0.3)',
                        '&:hover': {
                          boxShadow: '0 8px 18px rgba(76, 175, 80, 0.4)',
                        },
                      }}
                    >
                      Choose Plan
                    </MDButton>
                  </MDBox>
                </Grid>
              );
            })
          ) : (
            <Grid item xs={12}>
              <Typography
                variant="body2"
                color="text.secondary"
                align="center"
                sx={{
                  border: '1px dashed #ccc',
                  borderRadius: '8px',
                  p: 3,
                  fontStyle: 'italic',
                }}
              >
                🚫 No plans available for your role.
              </Typography>
            </Grid>
          )}

          {/* Back Button */}
          <Grid item xs={12}>
            <MDBox display="flex" justifyContent="flex-start" mt={3}>
              <MDButton
                type="button"
                onClick={() => {
                  if (getrole === "Services") handleServiceReviewDetails();
                  if (getrole === "Vendors") handleImageDetailsSubmit();
                }}
                variant="gradient"
                color="info"
                sx={{
                  fontSize: 14,
                  px: 4,
                  py: 1.2,
                  fontWeight: 'bold',
                  borderRadius: '8px',
                  boxShadow: '0 4px 10px rgba(0, 123, 255, 0.2)',
                }}
              >
                ⬅ Back
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>

      );
    }
  };

  const handleservicesSaveBusinessDetails = async (e) => {
    e.preventDefault();
    setStep(2); // Move to Step 2
    return;
  };
  const handleServiceReviewDetails = async (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setStep(9);
  };

  const handleSaveBusinessDetails = async (e) => {
    e.preventDefault();
    setStep(2); // Move to Step 2
    setIsEditingStep1(false); // Reset editing state
  };
  const handleservicestep4 = async (e) => {
    setStep(6);
    return;
  };
  const handleservicestep6 = async (e) => {
    setStep(7);
    return;
  };

  const handleBankDetailsSubmit = async () => {
    setStep(3);
    return;
  }
  const handleBankDetailsServicesSubmit = async () => {
    setStep(4);
    return;
  }
  const handleImageDetailsSubmit = async () => {
    setStep(8);
    return;
  }
  const handleMovetoPaymentPlan = async () => {
    setStep(10);
    return;
  }

  const normalizeRole = (role) => {
    if (!role) return null;

    const r = role.toLowerCase();
    if (r.includes("admin")) return "Admin";
    if (r.includes("marketing")) return "Marketing Manager";
    if (r.includes("telecaller")) return "Telecaller";

    return role; // fallback
  };

  const handleSubmit = async (selectedPlan) => {
    try {
      Swal.fire({
        title: "Redirecting to Payment...",
        html: "Please wait...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      // 1️⃣ Razorpay payment initialization
      const paymentInit = await api.post("/razor_payments/", {
        amount_paid: selectedPlan.discountedAmount || selectedPlan.total_amount,
        coupon_code: selectedPlan.couponCode || null,
        payment_method: "Online",
        user_id: email,
        type_of_vendor: "vendor",
        plan_name: selectedPlan.name,
        plan_validity_days: selectedPlan.validity_days, // ✅ FIXED
      });

      const {
        razorpay_order_id,
        razorpay_key_id,
        amount,
        payment_id,
      } = paymentInit.data;

      Swal.close(); // ✅ close loader AFTER order creation

      const options = {
        key: razorpay_key_id,
        amount,
        currency: "INR",
        order_id: razorpay_order_id,
        name: "Vendor Registration",
        description: "Registration Payment",
        image: "/assets/images/logo.png",

        handler: async function (razorpayResponse) {
          try {
            // 2️⃣ Confirm payment
            await api.put(`/razor_payments/${payment_id}`, {
              razorpay_order_id: razorpayResponse.razorpay_order_id,
              razorpay_payment_id: razorpayResponse.razorpay_payment_id,
              razorpay_signature: razorpayResponse.razorpay_signature,
              payment_status: "success",
              payment_method: "Online",
              paid_at: new Date().toISOString(),
              user_id: email,
              type_of_vendor: "vendor",
              plan_name: selectedPlan.name,
              plan_validity_days: selectedPlan.validity_days, // ✅ FIXED
            });

            // 3️⃣ Prepare FormData
            const formData = new FormData();
            formData.append("business_name", Input.businessName);
            formData.append("owner_name", Input.ownerName);
            formData.append(
              "business_category",
              businessCategory === "Others" ? Input.others : businessCategory
            );
            formData.append("keywords", Input.keywords);
            formData.append("business_type", Input.businessType);
            formData.append("mobile_number", mobileNumber);
            formData.append("email", email);
            formData.append("password", Input.password);
            formData.append("account_no", Input.accountNumber);
            formData.append("ifsc_code", Input.ifscCode);
            formData.append("passbook_name", Input.accountHolderName);
            formData.append("bank_name", Input.bankName);
            formData.append("branch_name", Input.branchName);
            formData.append("pan_card_number", Input.panCardNumber);
            formData.append("gst", Input.gstNumber);
            formData.append("referred_by_code", referralCode);

            formData.append("aadhar_number", "1234556777");

            // ✅ FIXED FIELDS
            formData.append(
              "no_of_notifications",
              selectedPlan.no_of_notifications
            );
            formData.append(
              "no_of_photos",
              selectedPlan.total_images_allowed
            );

            // Files
            if (files.vendorPhoto)
              formData.append("vendor_photo", files.vendorPhoto);
            if (files.shopPhoto)
              formData.append("shop_photo", files.shopPhoto);
            if (files.gpsPhoto && files.gpsPhoto.name !== "dummy")
              formData.append("gps_photo", files.gpsPhoto);

            files.userProofDoc.forEach((file) => {
              formData.append("user_proof_doc", file);
            });

            // 4️⃣ Submit vendor registration
            const response = await api.post(
              "/vendor_register/register_vendor",
              formData,
              { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (response.data.status === 1) {
              // 5️⃣ Incentive (FIXED AMOUNT)
              try {
                if (referralCode) {
                  const paidAmount =
                    selectedPlan.discountedAmount ||
                    selectedPlan.total_amount;
                  console.log("💰 Paid Amount:", paidAmount);

                  // 1️⃣ Get role using referral code
                  const roleRes = await api.get(`/login/by-code/${referralCode}`);
                  console.log("✅ Role API response:", roleRes.data);
                  // 2️⃣ Call incentive API

                  await api.post(
                    "/incentive_earning",
                    {
                      referral_id: referralCode,
                      paid_amount: paidAmount,
                      admin_email: roleRes.data.email,
                      role: normalizeRole(roleRes.data.role),
                    },
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );


                }
              } catch (err) {
                console.error("Incentive update failed:", err);
              }

              Swal.fire({
                icon: "success",
                title: "Vendor Registered Successfully!",
                text: "Please wait for approval.",
                timer: 2000,
                showConfirmButton: false,
                didClose: () => navigate("/login"),
              });
            } else {
              Swal.fire(
                "Upload Failed",
                response.data.msg || "Registration failed",
                "error"
              );
            }
          } catch (err) {
            console.error("Post-payment error:", err);
            Swal.fire(
              "Error",
              "Payment successful but registration failed.",
              "error"
            );
          }
        },

        prefill: {
          name: Input.businessName,
          email,
          contact: mobileNumber,
        },

        theme: { color: "#0f9d58" },
      };

      if (window.Razorpay) {
        new window.Razorpay(options).open();
      } else {
        Swal.fire("Error", "Razorpay not loaded", "error");
      }
    } catch (error) {
      console.error("Razorpay init error:", error);
      Swal.close();
      Swal.fire(
        "Error",
        "An unexpected error occurred. Please try again later.",
        "error"
      );
    }
  };


  const handleSubmitservices = async (selectedPlan) => {
    Swal.fire({
      title: "Redirecting to Payment...",
      html: "Please wait...",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      // 1️⃣ Create Razorpay Order
      const paymentInit = await api.post("/razor_payments/", {
        amount_paid: selectedPlan.discountedAmount || selectedPlan.total_amount,
        coupon_code: selectedPlan.couponCode || null,
        payment_method: "Online",
        user_id: Inputservices.email,
        type_of_vendor: "service_provider",
        plan_name: selectedPlan.name,
        plan_validity_days: selectedPlan.validity_days, // ✅ FIXED
      });

      const {
        razorpay_order_id,
        razorpay_key_id,
        amount,
        payment_id,
      } = paymentInit.data;

      Swal.close(); // ✅ Close loader AFTER order creation

      const options = {
        key: razorpay_key_id,
        amount,
        currency: "INR",
        order_id: razorpay_order_id,
        name: `${selectedPlan.name} Plan`,
        description: "Service Registration Payment",
        image: "/assets/images/logo.png",

        handler: async (razorpayResponse) => {
          try {
            // 2️⃣ Confirm payment
            await api.put(`/razor_payments/${payment_id}`, {
              razorpay_order_id: razorpayResponse.razorpay_order_id,
              razorpay_payment_id: razorpayResponse.razorpay_payment_id,
              razorpay_signature: razorpayResponse.razorpay_signature,
              payment_status: "success",
              payment_method: "Online",
              paid_at: new Date().toISOString(),
              user_id: Inputservices.email,
              type_of_vendor: "service_provider",
              plan_name: selectedPlan.name,
              plan_validity_days: selectedPlan.validity_days, // ✅ FIXED
            });

            // 3️⃣ Format specializations
            const formattedSpecializations = specializations.reduce((acc, item) => {
              if (!acc[item.service_type]) acc[item.service_type] = [];
              if (item.service_specializations) {
                acc[item.service_type].push(
                  ...item.service_specializations.split(", ")
                );
              }
              return acc;
            }, {});

            // 4️⃣ Prepare FormData
            const formData = new FormData();
            formData.append("owner_name", Inputservices.businessName);
            formData.append("services_type", servicetype);
            formData.append("email", Inputservices.email);
            formData.append("password", Inputservices.password);
            formData.append("keywords", Inputservices.keywords);
            formData.append("mobile_number", mobileNumberService);

            formData.append("account_no", Input.accountNumber || "");
            formData.append("ifsc_code", Input.ifscCode || "");
            formData.append("passbook_name", Input.accountHolderName || "");
            formData.append("bank_name", Input.bankName || "");
            formData.append("branch_name", Input.branchName || "");
            formData.append("pan_card_number", Input.panCardNumber || "");

            formData.append("subservices", JSON.stringify(formattedSpecializations));
            formData.append("experiance", Inputservices.experiance || "");
            formData.append("details", Inputservices.details || "");
            formData.append("worklocation", Inputservices.operatinglocation || "");
            formData.append("homeaddress", Inputservices.homeaddress || "");
            formData.append("availabiledays", JSON.stringify(selectedDays));
            formData.append("referred_by_code", referralCode);

            // Files
            if (profilephoto) formData.append("profile_photo", profilephoto);

            if (workPlaceGps) {
              formData.append("work_place_gps", workPlaceGps);
            } else {
              formData.append(
                "work_place_gps",
                new File(["dummy"], "dummy.png", { type: "image/png" })
              );
            }

            if (idphoto?.length) {
              idphoto.forEach((file, idx) =>
                formData.append(`idproof_photo[${idx}]`, file)
              );
            }

            if (experienceCertificates?.length) {
              experienceCertificates.forEach((file, idx) =>
                formData.append(`experience_certificates[${idx}]`, file)
              );
            }

            // 5️⃣ Register service provider
            const registerResponse = await api.post(
              "/services_register/register_service",
              formData,
              { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (registerResponse.data.success || registerResponse.data.status === 1) {
              // 6️⃣ Incentive – FIXED AMOUNT
              try {
                if (referralCode) {
                  const paidAmount =
                    selectedPlan.discountedAmount ||
                    selectedPlan.total_amount;

                  // 1️⃣ Get role using referral code
                  const roleRes = await api.get(`/login/by-code/${referralCode}`);

                  // 2️⃣ Call incentive API
                  await api.post(
                    "/incentive_earning",
                    {
                      referral_id: referralCode,
                      paid_amount: paidAmount,
                      admin_email: roleRes.data.email,
                      role: normalizeRole(roleRes.data.role),
                    },
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );
                }
              } catch (err) {
                console.error("Incentive update failed:", err);
              }

              Swal.fire({
                icon: "success",
                title: "Registration Complete!",
                text: "Payment and registration successful.",
                timer: 2000,
                showConfirmButton: false,
                didClose: () => navigate("/login"),
              });
            } else {
              Swal.fire(
                "Registration Failed",
                registerResponse.data.msg || "Some error occurred.",
                "error"
              );
            }
          } catch (err) {
            console.error("Post-payment registration error:", err);
            Swal.fire(
              "Error",
              "Payment successful but registration failed.",
              "error"
            );
          }
        },

        prefill: {
          name: Inputservices.businessName,
          email: Inputservices.email,
          contact: mobileNumberService,
        },

        theme: { color: "#0f9d58" },
      };

      if (window.Razorpay) {
        new window.Razorpay(options).open();
      } else {
        Swal.fire("Error", "Razorpay not loaded", "error");
      }
    } catch (err) {
      Swal.close();
      Swal.fire(
        "Error",
        "Failed to initiate payment. Please try again later.",
        "error"
      );
    }
  };

  const renderStepTitle = () => {
    if (getrole === "Vendors") {
      // Steps for vendors
      return step === 1
        ? "Business Details"
        : step === 2
          ? "Bank Details"
          : step === 3
            ? "Upload Photos"
            : step === 10
              ? "Choose Your Payment Plan"
              : "";
    } else {
      // Steps for service users
      return step === 1
        ? "Services Details"
        : step === 2
          ? "Bank Details"
          : step === 4 || step === 5 || step === 7
            ? "Services Details"
            : step === 6
              ? "Upload Documents"
              : step === 10
                ? "Choose Your Payment Plan"
                : "";
    }
  };


  // JSX
  <MDTypography variant="h4" align="center">
    {renderStepTitle()}
  </MDTypography>;

  return (
    <CoverLayout image={bgImage} coverHeight="10vh">

      <Card className="customCard"

        sx={{
          maxWidth: "1200px", // Increased the card width
          margin: "auto",
          padding: "30px", // Added padding for spacing
          elevation: 2// Added elevation for shadow
        }}>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-6}
          p={3}
          mb={1}
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            {/* Left Column: Logo inside white circle */}
            <div style={{
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              overflow: 'hidden',
              backgroundColor: 'white',
              marginRight: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <img
                src={logo}
                alt="Logo"
                style={{ height: 40, width: 40, objectFit: "contain" }}
              />
            </div>

            {/* Right Column: Texts */}
            <Box textAlign="left">
              <MDTypography variant="h4" fontWeight="medium" color="white" mb={0.5}>
                Join us today
              </MDTypography>
              <MDTypography variant="h6" fontWeight="medium" color="white">
                {renderStepTitle()}
              </MDTypography>
            </Box>
          </Box>
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            {renderFormContent()}
          </MDBox>
        </MDBox>
        <Dialog
          open={showTermsModal}
          onClose={() => setShowTermsModal(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle sx={{ textAlign: "center" }}>
            <span style={{ color: "#3364beff", fontWeight: 700 }}>
              Terms & Conditions
            </span>
          </DialogTitle>

          <DialogContent dividers>
            {loading ? (
              <div style={{ textAlign: "center", padding: 20 }}>Loading...</div>
            ) : termsList ? (
              <div>
                <h3 style={{ color: "#1976d2", marginBottom: 10 }}>
                  {termsList.title}
                </h3>
                <div
                  style={{
                    lineHeight: 1.6,
                    color: "#333",
                    textAlign: "justify",
                    whiteSpace: "pre-line",
                  }}
                >
                  {termsList.content}
                </div>

              </div>
            ) : (
              <div style={{ textAlign: "center", padding: 20 }}>
                No terms available.
              </div>
            )}

            <div style={{ marginTop: 20 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                />
                I have read and agree to the Terms and Conditions
              </label>
            </div>
          </DialogContent>

          <DialogActions sx={{ justifyContent: "space-between", padding: "16px" }}>
            <MDButton onClick={() => setShowTermsModal(false)} color="secondary">
              Cancel
            </MDButton>
            <MDButton
              onClick={() => {
                setShowTermsModal(false);
                generateCaptcha();
                setShowCaptcha(true);
              }}
              color="success"
              disabled={!isChecked}
            >
              I Accept
            </MDButton>
          </DialogActions>
        </Dialog>


        <Dialog open={showCaptcha} onClose={() => setShowCaptcha(false)} maxWidth="xs" fullWidth>
          <DialogTitle sx={{ textAlign: 'center', color: '#3364beff', fontWeight: 700 }}>
            Verify Captcha
          </DialogTitle>
          <DialogContent dividers>
            <div style={{ textAlign: 'center', marginBottom: 16 }}>
              <p style={{ fontSize: 16, color: '#333', marginBottom: 8 }}>
                Please enter the number shown below:
              </p>
              <MDBox
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 32,
                  fontWeight: 'bold',
                  letterSpacing: 6,
                  background: '#f3f6fd',
                  color: '#3364beff', // blue shade
                  padding: '14px 28px',
                  borderRadius: 2,
                  boxShadow: '0 1px 6px rgba(51,100,190,0.09)',
                  userSelect: 'none'
                }}
              >
                {captchaValue}
                {/* Refresh Button: IconButton next to captcha */}
                <IconButton
                  aria-label="Regenerate Captcha"
                  size="small"
                  onClick={generateCaptcha}
                  sx={{
                    marginLeft: 1,
                    color: '#1976d2',
                    background: '#fff',
                    border: '1px solid #dbe7fd',
                    '&:hover': { background: '#f4f6fa' }
                  }}
                >
                  <Refresh fontSize="small" />
                </IconButton>
              </MDBox>
            </div>
            <TextField
              fullWidth
              variant="outlined"
              label="Enter number"
              value={captchaInput}
              onChange={(e) => setCaptchaInput(e.target.value)}
              autoFocus
              inputProps={{ style: { textAlign: 'center', fontSize: 18, letterSpacing: 2 } }}
              sx={{
                marginTop: 1,
                marginBottom: 1
              }}
            />
          </DialogContent>
          <DialogActions>
            <MDButton onClick={() => setShowCaptcha(false)} color="secondary" variant="outlined">
              Cancel
            </MDButton>
            <MDButton
              onClick={() => {
                if (captchaInput === captchaValue) {
                  setSnackbarMessage("Captcha is verified. Proceeding...");
                  setSnackbarSeverity("success");
                  setSnackbarOpen(true);

                  // Delay next step and dialog close so user sees message
                  setTimeout(() => {
                    setShowCaptcha(false);
                    setStep(10); // Proceed to payment step
                  }, 1200); // 1.2 seconds delay
                } else {
                  generateCaptcha(); // Refresh captcha
                  setSnackbarMessage("Captcha does not match. Please try again.");
                  setSnackbarSeverity("error");
                  setSnackbarOpen(true);
                }
              }}
              color="success"
              variant="contained"
            >
              Verify
            </MDButton>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={4000}
          onClose={() => setSnackbarOpen(false)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity || "info"} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>



      </Card>
    </CoverLayout>
  );
}

export default Cover;